<template>
  <v-container fluid>
    <v-breadcrumbs :items="breadItems"
                   class="breadcrumb mx-16">
    </v-breadcrumbs>
    <div class="d-flex justify-center">
      <svg xmlns="http://www.w3.org/2000/svg"
           viewBox="30 70 1000 700"
           id="cancer-hallmark">
        <!-- <title>Hallmarks of Cancer</title> -->
        <g id="fills"
           data-name="fills">
          <path id="upp"
                fill="#c4c2c2"
                d="M403,165.63a262.7,262.7,0,0,0-119.1,86.52l94,68.32a146.3,146.3,0,0,1,61-44.28Z" />
          <path id="aiam"
                fill="#c4c2c2"
                d="M604.61,504.33a146.31,146.31,0,0,1-60.84,44.31l35.93,110.57a262.71,262.71,0,0,0,118.95-86.56Z" />
          <path id="ioav"
                fill="#c4c2c2"
                d="M529,553.44a146.66,146.66,0,0,1-76-.1L417.14,663.9a263.43,263.43,0,0,0,147.8.1Z" />
          <path id="giam"
                fill="#c4c2c2"
                d="M377.9,504.39l-94,68.32A262.7,262.7,0,0,0,403.1,659.34L439,548.77A146.3,146.3,0,0,1,377.9,504.39Z" />
          <path id="sps"
                fill="#c4c2c2"
                d="M491.23,150.4a262.13,262.13,0,0,0-73.46,10.45l35.93,110.57a146.72,146.72,0,0,1,75.42.09L565,160.94A262.07,262.07,0,0,0,491.23,150.4Z" />
          <path id="egs"
                fill="#c4c2c2"
                d="M579.08,165.49,543.15,276.06a146.3,146.3,0,0,1,61.4,44.48l94-68.32A262.69,262.69,0,0,0,579.08,165.49Z" />
          <path id="dcm"
                fill="#c4c2c2"
                d="M274.78,264.7a260.68,260.68,0,0,0-45.49,140H345.52A145.09,145.09,0,0,1,368.81,333Z" />
          <path id="rcd"
                fill="#c4c2c2"
                d="M345.52,420.22H229.28a260.72,260.72,0,0,0,45.45,139.94l94-68.32A145.12,145.12,0,0,1,345.52,420.22Z" />
          <path id="aid"
                fill="#c4c2c2"
                d="M707.72,264.76l-94,68.32a145.12,145.12,0,0,1,23.24,71.62H753.17A260.72,260.72,0,0,0,707.72,264.76Z" />
          <path id="tpi"
                fill="#c4c2c2"
                d="M636.93,420.22a145.09,145.09,0,0,1-23.2,71.56l94,68.32a260.68,260.68,0,0,0,45.4-139.88Z" />
        </g>
        <g id="edges"
           data-name="edges">
          <path id="upp"
                @click="clickRegion('upp')"
                @mouseover="mouseOverRegion('upp')"
                @mouseleave="mouseLeaveRegion('upp')"
                fill="none"
                stroke="#231815"
                stroke-miterlimit="10"
                d="M403,165.63a262.7,262.7,0,0,0-119.1,86.52l94,68.32a146.3,146.3,0,0,1,61-44.28Z" />
          <path id="aiam"
                @click="clickRegion('aiam')"
                @mouseover="mouseOverRegion('aiam')"
                @mouseleave="mouseLeaveRegion('aiam')"
                fill="none"
                stroke="#231815"
                stroke-miterlimit="10"
                d="M604.61,504.33a146.31,146.31,0,0,1-60.84,44.31l35.93,110.57a262.71,262.71,0,0,0,118.95-86.56Z" />
          <path id="giam"
                @click="clickRegion('giam')"
                @mouseover="mouseOverRegion('giam')"
                @mouseleave="mouseLeaveRegion('giam')"
                fill="none"
                stroke="#231815"
                stroke-miterlimit="10"
                d="M377.9,504.39l-94,68.32A262.7,262.7,0,0,0,403.1,659.34L439,548.77A146.3,146.3,0,0,1,377.9,504.39Z" />
          <path id="ioav"
                @click="clickRegion('ioav')"
                @mouseover="mouseOverRegion('ioav')"
                @mouseleave="mouseLeaveRegion('ioav')"
                fill="none"
                stroke="#231815"
                stroke-miterlimit="10"
                d="M529,553.44a146.66,146.66,0,0,1-76-.1L417.14,663.9a263.43,263.43,0,0,0,147.8.1Z" />
          <path id="sps"
                @click="clickRegion('sps')"
                @mouseover="mouseOverRegion('sps')"
                @mouseleave="mouseLeaveRegion('sps')"
                fill="none"
                stroke="#231815"
                stroke-miterlimit="10"
                d="M491.23,150.4a262.13,262.13,0,0,0-73.46,10.45l35.93,110.57a146.72,146.72,0,0,1,75.42.09L565,160.94A262.07,262.07,0,0,0,491.23,150.4Z" />
          <path id="egs"
                @click="clickRegion('egs')"
                @mouseover="mouseOverRegion('egs')"
                @mouseleave="mouseLeaveRegion('egs')"
                fill="none"
                stroke="#231815"
                stroke-miterlimit="10"
                d="M579.08,165.49,543.15,276.06a146.3,146.3,0,0,1,61.4,44.48l94-68.32A262.69,262.69,0,0,0,579.08,165.49Z" />
          <path id="dcm"
                @click="clickRegion('dcm')"
                @mouseover="mouseOverRegion('dcm')"
                @mouseleave="mouseLeaveRegion('dcm')"
                fill="none"
                stroke="#231815"
                stroke-miterlimit="10"
                d="M274.78,264.7a260.68,260.68,0,0,0-45.49,140H345.52A145.09,145.09,0,0,1,368.81,333Z" />
          <path id="rcd"
                @click="clickRegion('rcd')"
                @mouseover="mouseOverRegion('rcd')"
                @mouseleave="mouseLeaveRegion('rcd')"
                fill="none"
                stroke="#231815"
                stroke-miterlimit="10"
                d="M345.52,420.22H229.28a260.72,260.72,0,0,0,45.45,139.94l94-68.32A145.12,145.12,0,0,1,345.52,420.22Z" />
          <path id="aid"
                @click="clickRegion('aid')"
                @mouseover="mouseOverRegion('aid')"
                @mouseleave="mouseLeaveRegion('aid')"
                fill="none"
                stroke="#231815"
                stroke-miterlimit="10"
                d="M707.72,264.76l-94,68.32a145.12,145.12,0,0,1,23.24,71.62H753.17A260.72,260.72,0,0,0,707.72,264.76Z" />
          <path id="tpi"
                @click="clickRegion('tpi')"
                @mouseover="mouseOverRegion('tpi')"
                @mouseleave="mouseLeaveRegion('tpi')"
                fill="none"
                stroke="#231815"
                stroke-miterlimit="10"
                d="M636.93,420.22a145.09,145.09,0,0,1-23.2,71.56l94,68.32a260.68,260.68,0,0,0,45.4-139.88Z" />
        </g>
        <g id="sps1"
           @click="clickRegion('sps')"
           @mouseover="mouseOverRegion('sps')"
           @mouseleave="mouseLeaveRegion('sps')"
           data-name="图层 3"
           style="cursor:pointer">
          <ellipse class="cls-46"
                   cx="493.02"
                   cy="217.26"
                   rx="15.41"
                   ry="11.67"
                   transform="translate(243.22 694.62) rotate(-86.16)" />
          <ellipse class="cls-47"
                   cx="493"
                   cy="217.23"
                   rx="9.12"
                   ry="6.15"
                   transform="translate(243.23 694.58) rotate(-86.16)" />
          <ellipse class="cls-48"
                   cx="473.99"
                   cy="219.58"
                   rx="8.96"
                   ry="11.46"
                   transform="translate(-30.42 83.73) rotate(-9.78)" />
          <path class="cls-49"
                d="M482.8,218.06c-1.07-6.24-5.88-10.62-10.76-9.79l-.59.13c3.72.94,6.91,4.72,7.76,9.66,1,6-1.77,11.49-6.3,12.67a7.2,7.2,0,0,0,3,.13C480.78,230,483.86,224.29,482.8,218.06Z" />
          <ellipse class="cls-46"
                   cx="473.97"
                   cy="219.58"
                   rx="4.14"
                   ry="5.95"
                   transform="translate(-30.28 83.23) rotate(-9.73)" />
          <path class="cls-48"
                d="M478.05,218.86c-.55-3.24-2.83-5.55-5.08-5.17a3,3,0,0,0-1.26.53,6.85,6.85,0,0,1,2.75,4.63c.44,2.58-.34,5-1.82,6a3.28,3.28,0,0,0,2.33.53c2.25-.38,3.63-3.32,3.08-6.56Z" />
          <ellipse class="cls-48"
                   cx="485.67"
                   cy="189.06"
                   rx="10.51"
                   ry="13.45"
                   transform="translate(-27.91 100.43) rotate(-11.48)" />
          <path class="cls-49"
                d="M495.93,186.78c-1.55-7.26-7.41-12.13-13.08-10.88l-.39.1c4.16.87,8,4.63,9.65,9.92,2.16,7.1-.57,14.26-6.11,16a8.32,8.32,0,0,1-1.18.27,8.43,8.43,0,0,0,3.67,0c5.67-1.25,9-8.15,7.45-15.42Z" />
          <ellipse class="cls-46"
                   cx="485.66"
                   cy="189.05"
                   rx="4.86"
                   ry="6.98"
                   transform="translate(-28.27 102.54) rotate(-11.71)" />
          <path class="cls-48"
                d="M490.41,188c-.81-3.77-3.59-6.36-6.21-5.78a3.45,3.45,0,0,0-.43.13c1.93.66,3.64,2.82,4.25,5.65.76,3.56-.5,6.89-2.85,7.75a3.6,3.6,0,0,0,2,.13c2.62-.58,4.09-4.1,3.28-7.87Z" />
          <ellipse class="cls-48"
                   cx="506.47"
                   cy="217.14"
                   rx="13.44"
                   ry="10.61"
                   transform="translate(-27.17 354.57) rotate(-37.65)" />
          <path class="cls-49"
                d="M517.23,209.12c-2.13-2.93-5.86-4.15-9.81-3.6a9.17,9.17,0,0,1,6.21,3.6c3.44,4.74,1.4,12.17-4.56,16.6a15.86,15.86,0,0,1-7.21,3,14.81,14.81,0,0,0,10.8-3C518.64,221.29,520.68,213.86,517.23,209.12Z" />
          <ellipse class="cls-46"
                   cx="506.44"
                   cy="217.12"
                   rx="6.98"
                   ry="4.9"
                   transform="translate(-28.14 350.71) rotate(-37.24)" />
          <ellipse class="cls-48"
                   cx="500.31"
                   cy="186.34"
                   rx="13.49"
                   ry="10.56"
                   transform="translate(157.1 595.29) rotate(-70.42)" />
          <path class="cls-49"
                d="M505,173.7a8.64,8.64,0,0,0-4.83-.37,8.36,8.36,0,0,1,1.24.37c5.45,2.08,7.76,9.43,5.17,16.41-1.85,5-5.7,8.44-9.74,9.25,5.16,1.1,10.93-2.79,13.33-9.25C512.79,183.12,510.47,175.77,505,173.7Z" />
          <ellipse class="cls-46"
                   cx="500.34"
                   cy="186.36"
                   rx="7.01"
                   ry="4.88"
                   transform="translate(154.52 593.16) rotate(-70.06)" />
          <path class="cls-48"
                d="M502.76,179.78a3.93,3.93,0,0,0-3.12.22c2.16,1.22,2.91,4.69,1.65,8.09a8.18,8.18,0,0,1-3.88,4.61,3.48,3.48,0,0,0,.47.22c2.52,1,5.65-1.2,7-4.83S505.28,180.74,502.76,179.78Z" />
          <ellipse class="cls-48"
                   cx="503.56"
                   cy="203.48"
                   rx="15.4"
                   ry="12.04"
                   transform="translate(188.4 645.8) rotate(-76.53)" />
          <path class="cls-49"
                d="M507.3,188.57a9.66,9.66,0,0,0-4.22-.14l.63.14c6.43,1.68,10,9.72,7.88,18-1.63,6.45-6.2,11.11-11.2,12,6.25,1.19,12.78-4.06,14.79-12,2.08-8.24-1.45-16.28-7.88-18Z" />
          <ellipse class="cls-46"
                   cx="503.54"
                   cy="203.53"
                   rx="9.11"
                   ry="6.35"
                   transform="translate(185.99 644.14) rotate(-76.23)" />
          <path class="cls-48"
                d="M505.77,194.66a4.8,4.8,0,0,0-3,.21c3,1.26,4.44,5.65,3.29,10.22-.87,3.47-3,6.1-5.4,7a4.51,4.51,0,0,0,.62.21c3.39.88,7.14-2.36,8.37-7.24s-.52-9.55-3.91-10.44Z" />
          <ellipse class="cls-46"
                   cx="479.72"
                   cy="203.55"
                   rx="11.76"
                   ry="15.3"
                   transform="translate(-14.17 369.79) rotate(-41.6)" />
          <path class="cls-48"
                d="M488.19,195.42c-4-4.29-9.26-6.26-13.69-5.58a17.49,17.49,0,0,1,10.1,5.58c5.75,6.19,6.61,14.85,1.92,19.34a9.5,9.5,0,0,1-5.2,2.51,10.31,10.31,0,0,0,8.79-2.51c4.69-4.49,3.83-13.16-1.92-19.34Z" />
          <ellipse class="cls-47"
                   cx="479.7"
                   cy="203.56"
                   rx="6.2"
                   ry="9.05"
                   transform="translate(-12.76 373.96) rotate(-42.08)" />
          <path class="cls-46"
                d="M484.18,199.27c-2.73-2.94-6.33-4.19-8.93-3.35a11.47,11.47,0,0,1,5.33,3.35c3.4,3.66,4.16,8.55,1.69,10.92a4.4,4.4,0,0,1-1.71,1,5.45,5.45,0,0,0,5.3-1c2.47-2.37,1.72-7.26-1.69-10.92Z" />
          <path class="cls-10"
                d="M518,208.59a9.38,9.38,0,0,0-1.88-1.93,18.68,18.68,0,0,0-.82-11.94,13,13,0,0,0-3.93-5.16,16.29,16.29,0,0,0,.1-9.93,10.44,10.44,0,0,0-6.09-6.78,10,10,0,0,0-7.76.39,14.52,14.52,0,0,0-5.59,4.63,10.41,10.41,0,0,0-9.32-2.85c-5.43,1.2-9,7.12-8.49,14a10.31,10.31,0,0,0-5.5,2.72c-.22.21-.43.43-.63.66a.9.9,0,0,0,1.35,1.18c.16-.19.34-.37.51-.54a9,9,0,0,1,6.67-2.39A16,16,0,0,1,487.54,196c5.41,5.82,6.29,13.94,2,18.09a9,9,0,0,1-6.67,2.39,16,16,0,0,1-10.95-5.42,17.85,17.85,0,0,1-4.21-7.45,12.28,12.28,0,0,1,.09-7.24.9.9,0,0,0-1.69-.59,14.06,14.06,0,0,0-.13,8.3,18.81,18.81,0,0,0,2.18,5A10.68,10.68,0,0,0,464.8,214a14.57,14.57,0,0,0-.54,7.24c1.05,6.16,5.59,10.64,10.46,10.64a8,8,0,0,0,1.33-.11,8.92,8.92,0,0,0,6.31-4.83l.11-.22a14.32,14.32,0,0,0,3.17,4.12,10.49,10.49,0,0,0,6.23,2.7l.7,0a11.31,11.31,0,0,0,8.39-4,12.62,12.62,0,0,0,2.68.28,15,15,0,0,0,4.85-.84.9.9,0,0,0-.58-1.7c-4.68,1.61-9.21.58-11.53-2.62a8.84,8.84,0,0,1-1.12-7.6,10.74,10.74,0,0,0,4,2.19,4.66,4.66,0,0,0,.87,2.61,4.8,4.8,0,0,0,3.26,1.88,6.53,6.53,0,0,0,1,.07,9.47,9.47,0,0,0,5.49-2c3.17-2.36,4.57-6,3.33-8.67a19.47,19.47,0,0,0,2.33-4.61,7.55,7.55,0,0,1,1,1.11c3.15,4.34,1.19,11.22-4.37,15.35-.37.27-.74.53-1.13.77a.9.9,0,1,0,.95,1.53c.42-.26.85-.55,1.25-.85a16.39,16.39,0,0,0,6.13-8.66,10.56,10.56,0,0,0-1.39-9.18Zm-19.64-33.72a8.16,8.16,0,0,1,6.38-.34,8.69,8.69,0,0,1,5,5.66,14.37,14.37,0,0,1,0,8.37,10.53,10.53,0,0,0-3.71-1.13,9.37,9.37,0,0,0,.11-4.72,5.18,5.18,0,0,0-3.06-3.77,4.77,4.77,0,0,0-3.73.2,9.08,9.08,0,0,0-4.43,5.15,8.69,8.69,0,0,0,.45,7.67,18.13,18.13,0,0,0-2.67,3.83c-2.58-3.12-3.16-8.2-1.41-12.9A14,14,0,0,1,498.32,174.88Zm-1.63,15.8a8,8,0,0,1,3.4-9.9,3.07,3.07,0,0,1,2.35-.16c1.94.74,2.69,3.78,1.73,6.77a11.93,11.93,0,0,0-5.3,1.71A14.84,14.84,0,0,0,496.69,190.68ZM476,188.82c-.41-5.94,2.54-11,7.09-12a8.74,8.74,0,0,1,7.93,2.62,18.1,18.1,0,0,0-1.37,2.88c-.15.4-.28.8-.4,1.2a5.42,5.42,0,0,0-5.2-2.13,5.15,5.15,0,0,0-3.56,3.27,9.33,9.33,0,0,0-.57,4.66,14.67,14.67,0,0,0-3.24-.47Zm5.84,1.09c-.69-3.23.5-6.35,2.6-6.81,1.44-.32,3.08.69,4.17,2.56a.89.89,0,0,0,.12.16c-.68,4.51.46,9,3.19,11.75q-.17.43-.33.87a20.69,20.69,0,0,0-2.71-3.64A19.48,19.48,0,0,0,481.8,189.91Zm8.94,25.5a10.2,10.2,0,0,0,1.63-2,13.54,13.54,0,0,0,1.47,2.18h0a11.06,11.06,0,0,0,.62,9.39,3.63,3.63,0,0,1-2,.49,4.5,4.5,0,0,1-3.44-2.52,10.53,10.53,0,0,1-1.26-5.52,10.1,10.1,0,0,0,3-2ZM477.17,219a6.51,6.51,0,0,1-.41,3.82,2.75,2.75,0,0,1-1.93,1.7l-.34,0c-1.63,0-3.28-1.94-3.71-4.46a6.5,6.5,0,0,1,.41-3.82,2.78,2.78,0,0,1,1.87-1.69,19.06,19.06,0,0,0,3.27,2,7.2,7.2,0,0,1,.84,2.37Zm-1.42,11a6.21,6.21,0,0,1-1,.09c-4,0-7.77-3.86-8.68-9.15-.7-4.12.54-8.17,3.1-10.32a20.94,20.94,0,0,0,1.43,1.72q.47.5,1,1a5,5,0,0,0-2,2.24,8.79,8.79,0,0,0,1.59,9.3,4.68,4.68,0,0,0,3.32,1.54,3.89,3.89,0,0,0,.65-.06,4.48,4.48,0,0,0,3.25-2.71,8.31,8.31,0,0,0,.56-4.88,9.31,9.31,0,0,0-.27-1.12,15.21,15.21,0,0,0,3.25.66,12.25,12.25,0,0,1-1.13,7.8,7.17,7.17,0,0,1-5,3.91ZM499,228.9a9.17,9.17,0,0,1-7,2.83,8.72,8.72,0,0,1-5.17-2.25,13.21,13.21,0,0,1-3.45-5.11,14.68,14.68,0,0,0,.35-6.07,11.94,11.94,0,0,0,2.18-.3,12.11,12.11,0,0,0,1.51,5.83,6.22,6.22,0,0,0,4.87,3.41h.35a5.5,5.5,0,0,0,2.87-.84A9.65,9.65,0,0,0,499,228.9Zm9.75-8.51a7.19,7.19,0,0,1-5.14,1.55,3.09,3.09,0,0,1-2.08-1.16,2.77,2.77,0,0,1-.48-1.19,10.45,10.45,0,0,0,1.11.06,11.73,11.73,0,0,0,6-1.73,15.44,15.44,0,0,0,3.63-3c.18,1.76-1,4-3,5.5Zm5.52-14.07a16.13,16.13,0,0,1-7,10,9.43,9.43,0,0,1-7.28,1.2,10.09,10.09,0,0,1-6.64-6.25,13.16,13.16,0,0,0,.61-5.67,17.13,17.13,0,0,0-1.24-4.85l0-.11a16.13,16.13,0,0,1,7-10,9.43,9.43,0,0,1,7.28-1.2c5.95,1.55,9.2,9.12,7.24,16.87Z" />
          <path class="cls-10"
                d="M506,193.79a6,6,0,0,0-4.59.76,11.55,11.55,0,0,0-4.88,7.12,12.32,12.32,0,0,0,.25,7.25,6.47,6.47,0,0,0,4.3,4.27,5.42,5.42,0,0,0,1.37.18,6.31,6.31,0,0,0,3.22-.94,11.55,11.55,0,0,0,4.88-7.12,12.32,12.32,0,0,0-.25-7.25,6.47,6.47,0,0,0-4.3-4.27Zm2.82,11.09a9.74,9.74,0,0,1-4.05,6,4.19,4.19,0,0,1-3.22.57,4.74,4.74,0,0,1-3.08-3.17,10.51,10.51,0,0,1-.19-6.18,9.74,9.74,0,0,1,4.05-6,4.55,4.55,0,0,1,2.31-.69,3.6,3.6,0,0,1,.91.12,4.74,4.74,0,0,1,3.08,3.17,10.51,10.51,0,0,1,.19,6.18Z" />
          <path class="cls-10"
                d="M482.24,212.36h.22a5.68,5.68,0,0,0,4-1.52,6.38,6.38,0,0,0,1.63-5.76,12.46,12.46,0,0,0-3.28-6.42,11.46,11.46,0,0,0-7.67-3.89,5.74,5.74,0,0,0-4.25,1.51A6.38,6.38,0,0,0,471.3,202a12.46,12.46,0,0,0,3.28,6.42,11.46,11.46,0,0,0,7.67,3.89Zm-8.08-14.78a3.93,3.93,0,0,1,2.79-1h.16a9.65,9.65,0,0,1,6.41,3.32,10.65,10.65,0,0,1,2.82,5.47,4.65,4.65,0,0,1-1.09,4.19,4,4,0,0,1-3,1,9.65,9.65,0,0,1-6.41-3.32,10.65,10.65,0,0,1-2.82-5.47,4.65,4.65,0,0,1,1.09-4.19Z" />
        </g>
        <g id="upp1"
           @click="clickRegion('upp')"
           @mouseover="mouseOverRegion('upp')"
           @mouseleave="mouseLeaveRegion('upp')"
           style="cursor:pointer"
           data-name="图层 12">
          <path class="cls-6"
                d="M379.43,230.24,378.26,227a14.22,14.22,0,1,0-26.86,9.35l2.36,6.5h4l-2.83-7.8a10.43,10.43,0,0,1,6.23-13.36h0a10.43,10.43,0,0,1,13.36,6.23l1.31,3.61a1,1,0,0,0,1.21.57l1.78-.65A1,1,0,0,0,379.43,230.24Z" />
          <path class="cls-7"
                d="M367.6,272.24h0a17.06,17.06,0,0,1-17.06-17.06V243.81a1.9,1.9,0,0,1,1.9-1.9h30.33a1.9,1.9,0,0,1,1.9,1.9v11.37A17.06,17.06,0,0,1,367.6,272.24Z" />
          <path class="cls-8"
                d="M372.34,270.35a17.06,17.06,0,0,1-17.06-17.06V241.91h-2.84a1.9,1.9,0,0,0-1.9,1.9v11.37a17,17,0,0,0,25.68,14.7A17.06,17.06,0,0,1,372.34,270.35Z" />
          <circle class="cls-9"
                  cx="367.6"
                  cy="254.23"
                  r="2.84" />
          <path class="cls-10"
                d="M382.76,241H358.08l-2.28-6.27a9.54,9.54,0,1,1,17.92-6.52l1.31,3.61a1.84,1.84,0,0,0,2.35,1.1l1.78-.65a1.84,1.84,0,0,0,1.1-2.35l-1.17-3.22a15.11,15.11,0,1,0-28.53,9.95l1.59,4.38a2.79,2.79,0,0,0-2.51,2.77v11.37a17.95,17.95,0,0,0,35.9,0V243.81A2.79,2.79,0,0,0,382.76,241Zm-29.95-15.45a13.33,13.33,0,0,1,24.6,1.72v0l1.18,3.23a.06.06,0,0,1,0,.08l-1.78.65a.06.06,0,0,1-.08,0l-1.31-3.61a11.31,11.31,0,0,0-21.26,7.74l2.06,5.66H354l-1.81-5A13.21,13.21,0,0,1,352.81,225.58Zm31,29.61a16.17,16.17,0,0,1-32.34,0V243.81a1,1,0,0,1,1-1h30.33a1,1,0,0,1,1,1v11.37Z" />
          <path class="cls-10"
                d="M367.6,250.51a3.73,3.73,0,0,0-.89,7.36v3a.89.89,0,1,0,1.78,0v-3a3.73,3.73,0,0,0-.89-7.36Zm0,5.69a2,2,0,1,1,2-2A2,2,0,0,1,367.6,256.19Z" />
          <path class="cls-10"
                d="M362.3,266.37a12.48,12.48,0,0,1-6.79-8.53.89.89,0,1,0-1.74.38,14.27,14.27,0,0,0,7.76,9.76.89.89,0,0,0,.76-1.6Z" />
          <path class="cls-10"
                d="M380.87,252.4a.89.89,0,0,0-.89.89v1.9a12.34,12.34,0,0,1-1.77,6.37.89.89,0,1,0,1.52.92,14.12,14.12,0,0,0,2-7.29v-1.9A.89.89,0,0,0,380.87,252.4Z" />
          <path class="cls-10"
                d="M380.87,246.72a.89.89,0,0,0-.89.89v1.9a.89.89,0,0,0,1.78,0v-1.9A.89.89,0,0,0,380.87,246.72Z" />
        </g>
        <g id="dcm1"
           @click="clickRegion('dcm')"
           @mouseover="mouseOverRegion('dcm')"
           @mouseleave="mouseLeaveRegion('dcm')"
           style="cursor:pointer"
           data-name="图层 11">
          <path class="cls-11"
                d="M266.43,353.33a29.94,29.94,0,0,0,5.49,17.33l-2.66,2.66,9.9,2.33-2.64-9.59-2,2a26.46,26.46,0,0,1,22-41.18v-3.63A30.09,30.09,0,0,0,266.43,353.33Z" />
          <path class="cls-11"
                d="M323,353.33a26.46,26.46,0,0,1-26.46,26.46v3.63A30.09,30.09,0,0,0,321.11,336l2.66-2.66-9.9-2.33,2.64,9.59,2-2A26.33,26.33,0,0,1,323,353.33Z" />
          <path class="cls-11"
                d="M309,370a5.45,5.45,0,1,0-7.71-.08A5.46,5.46,0,0,0,309,370Z" />
          <path class="cls-12"
                d="M300.22,368.32a5.45,5.45,0,0,1,1.16-6.12,5.51,5.51,0,0,1,7.71.08,15.44,15.44,0,1,0-27.86-11.16,6.78,6.78,0,1,1,3.64,12.35A15.45,15.45,0,0,0,300.22,368.32ZM299,346.83a2.72,2.72,0,1,1-2.72-2.72A2.72,2.72,0,0,1,299,346.83Z" />
          <path class="cls-13"
                d="M300.22,368.32a5.45,5.45,0,0,1,1.16-6.12,5.51,5.51,0,0,1,7.71.08,15.43,15.43,0,0,0,1.41-2.4,8.17,8.17,0,0,0-13.06,8.78,15.46,15.46,0,0,1-8.1-3.49A9.32,9.32,0,0,0,294.6,357a9.53,9.53,0,0,0-9.52-9.82,15.45,15.45,0,0,1,12.8-9.24,15.47,15.47,0,0,0-16.64,13.17,6.78,6.78,0,1,1,3.64,12.35A15.48,15.48,0,0,0,300.22,368.32Z" />
          <path class="cls-14"
                d="M291.88,356.92a6.78,6.78,0,1,0-7,6.55A6.78,6.78,0,0,0,291.88,356.92Z" />
          <circle class="cls-14"
                  cx="296.3"
                  cy="346.83"
                  r="2.72" />
          <path class="cls-15"
                d="M296.52,337.89a15.4,15.4,0,0,1,11.65,5.31,6.41,6.41,0,1,0-11.65-5.31Z" />
          <path class="cls-16"
                d="M286.46,350.05a6.77,6.77,0,1,0-.07,13.27,6.78,6.78,0,0,1,.07-13.27Z" />
          <path class="cls-17"
                d="M306.54,360.84a5.44,5.44,0,1,0,0,10.53,5.45,5.45,0,0,1-2.45-9.17A5.33,5.33,0,0,1,306.54,360.84Z" />
          <path class="cls-12"
                d="M289.61,357.93H287.8v-1.82h1.82Zm-1.82-3.63H286v-1.82h1.82Z" />
          <path class="cls-10"
                d="M322.29,336.11l3.28-3.28-13-3.05L316,342.35l2.3-2.3a25.55,25.55,0,0,1-21.83,38.83h-.91v5.45h.91a31,31,0,0,0,19.83-7.17l-1.16-1.4a29.21,29.21,0,0,1-17.76,6.74v-1.82a27.37,27.37,0,0,0,21.83-42.58l-.62-.92L317,338.86l-1.82-6.61,6.83,1.61-2,2,.44.63A29.18,29.18,0,0,1,318.93,372l1.39,1.16a31,31,0,0,0,2-37.07Z" />
          <path class="cls-10"
                d="M274.69,366.61a25.55,25.55,0,0,1,21.83-38.83h.91v-5.45h-.91a31,31,0,0,0-25.77,48.22l-3.28,3.28,13,3.05L277,364.31Zm-3.63,6.2,2-2-.44-.63a29.18,29.18,0,0,1,22.95-46V326a27.37,27.37,0,0,0-21.83,42.58l.62.92,1.67-1.67,1.82,6.61Z" />
          <path class="cls-10"
                d="M296.49,369.68a16.46,16.46,0,0,0,3.25-.33,6.4,6.4,0,0,0,.92,1.19,6.32,6.32,0,0,0,4.49,1.91h.06a6.35,6.35,0,0,0,6.35-6.37,6.22,6.22,0,0,0-1.31-3.88,16.33,16.33,0,0,0-1-19.15A7.31,7.31,0,0,0,295.93,337a16.23,16.23,0,0,0-8.79,2.94l1,1.49a14.53,14.53,0,0,1,20.71,19.51,6.41,6.41,0,0,0-8.14.62,6.32,6.32,0,0,0-1.91,4.48,6.39,6.39,0,0,0,.19,1.61,14.47,14.47,0,0,1-12.18-3.46,7.69,7.69,0,1,0-4.34-14.73,14.56,14.56,0,0,1,4.31-6.94l-1.21-1.35a16.36,16.36,0,0,0-5.22,9.46q-.28.22-.55.47a7.69,7.69,0,0,0,4.6,13.28,16.29,16.29,0,0,0,12,5.33ZM298,337.06a5.51,5.51,0,0,1,6.51-1.79,5.53,5.53,0,0,1,3.26,6.25,16.3,16.3,0,0,0-9.78-4.47Zm4,25.8a4.49,4.49,0,0,1,3.15-1.27,4.64,4.64,0,0,1,3.28,1.35,4.39,4.39,0,0,1,1.28,3.16,4.54,4.54,0,1,1-7.71-3.23Zm-21.21-2.15a5.87,5.87,0,0,1,4.28-9.88h.2a5.87,5.87,0,1,1-4.48,9.88Z" />
          <path class="cls-10"
                d="M296.3,350.46a3.63,3.63,0,1,0-3.63-3.63A3.64,3.64,0,0,0,296.3,350.46Zm0-5.45a1.82,1.82,0,1,1-1.82,1.82A1.82,1.82,0,0,1,296.3,345Z" />
          <path class="cls-10"
                d="M316.5,374.64l1.29-1.28,1.28,1.29-1.29,1.28Z" />
        </g>
        <g id="rcd1"
           @click="clickRegion('rcd')"
           @mouseover="mouseOverRegion('rcd')"
           @mouseleave="mouseLeaveRegion('rcd')"
           style="cursor:pointer"
           data-name="图层 10">
          <path class="cls-10"
                d="M298.43,484.79c8.61,0,14.67-13.93,14.67-21.37a14.67,14.67,0,0,0-29.34,0C283.76,471,289.83,484.79,298.43,484.79Zm0-31.88a10.44,10.44,0,0,1,10.42,10.42c0,6.38-5.1,17.22-10.42,17.22S288,469.6,288,463.33A10.43,10.43,0,0,1,298.43,452.91Z" />
          <path class="cls-10"
                d="M315,491.28l3.82-3.82a2.11,2.11,0,0,0-3-3l-4.68,4.68h-25.6L281,484.58a2.11,2.11,0,1,0-3,3l3.83,3.72L278,495.1a2.06,2.06,0,0,0,0,3,2.2,2.2,0,0,0,3,.1l4.78-4.78H311.2l4.68,4.68a2.11,2.11,0,1,0,3-3Z" />
          <path class="cls-10"
                d="M296.3,466.61v-1.06a2.13,2.13,0,1,0-4.26,0v1.06a2.14,2.14,0,0,0,2.13,2.13A2.06,2.06,0,0,0,296.3,466.61Z" />
          <path class="cls-10"
                d="M303.33,468.74a2.13,2.13,0,0,0,2.13-2.13v-1.06a2.13,2.13,0,0,0-4.26,0v1.06A2.14,2.14,0,0,0,303.33,468.74Z" />
        </g>
        <g id="gim1"
           @click="clickRegion('giam')"
           @mouseover="mouseOverRegion('giam')"
           @mouseleave="mouseLeaveRegion('giam')"
           style="cursor:pointer"
           data-name="图层 9">
          <path class="cls-18"
                d="M365.66,605.94l-24.24-18.46,2.14-2.81,24.24,18.46Z" />
          <path class="cls-18"
                d="M368.78,599.48l-22-16.72,2.14-2.81,22,16.72Z" />
          <path class="cls-18"
                d="M370.49,592.2l-17.1-13,2.14-2.81,17.1,13Z" />
          <path class="cls-19"
                d="M395.52,565.59,372.38,548l2.14-2.81,23.14,17.62Z" />
          <path class="cls-19"
                d="M390,570.23l-20.63-15.71,2.14-2.81,20.63,15.71Z" />
          <path class="cls-19"
                d="M383.22,573.66,367.88,562l2.14-2.81,15.34,11.68Z" />
          <path class="cls-20"
                d="M375.56,567.83,367.88,562l2.14-2.81L377.7,565Z" />
          <path class="cls-21"
                d="M362,585.69l-8.56-6.52,2.14-2.81,8.56,6.52Z" />
          <path class="cls-20"
                d="M379.7,562.39l-10.33-7.86,2.14-2.81,10.33,7.86Z" />
          <path class="cls-21"
                d="M357.82,591.13l-11-8.37,2.14-2.81,11,8.37Z" />
          <path class="cls-20"
                d="M384,556.79,372.38,548l2.14-2.81L386.11,554Z" />
          <path class="cls-21"
                d="M353.55,596.73l-12.13-9.24,2.14-2.81,12.13,9.24Z" />
          <path class="cls-22"
                d="M362,574.25l6-.79-.84-5.31a33.46,33.46,0,0,1,.59-13.41,33,33,0,0,1,5.78-12,1.77,1.77,0,0,1,2.82,2.14,29.44,29.44,0,0,0-5.16,10.76,29.94,29.94,0,0,0-.52,12l.86,5.45,5.48-.62a29.94,29.94,0,0,0,11.43-3.69,29.44,29.44,0,0,0,9-7.84,1.77,1.77,0,0,1,2.82,2.14,33,33,0,0,1-10.07,8.77,33.45,33.45,0,0,1-12.77,4.13l-5.35.61.84,6a33.45,33.45,0,0,1-.75,13.09,33,33,0,0,1-5.71,11.74l-.59.78A1.77,1.77,0,0,1,363.1,606l.59-.78a29.47,29.47,0,0,0,5.1-10.49,30,30,0,0,0,.67-11.72l-.85-6.11-6.12.81a30,30,0,0,0-11.12,3.76,29.47,29.47,0,0,0-8.76,7.7L342,590a1.77,1.77,0,0,1-2.82-2.14l.59-.78a33,33,0,0,1,9.8-8.62A33.45,33.45,0,0,1,362,574.25Z" />
          <path class="cls-23"
                d="M362,574.25l6-.79-.84-5.31a33.46,33.46,0,0,1,.59-13.41,33,33,0,0,1,5.78-12,1.77,1.77,0,0,1,2.82,2.14,29.44,29.44,0,0,0-5.16,10.76,29.94,29.94,0,0,0-.52,12l.86,5.45-3,3.91-6.12.81a29.94,29.94,0,0,0-11.12,3.76,29.46,29.46,0,0,0-8.76,7.7L342,590a1.77,1.77,0,0,1-2.82-2.14l.59-.78a33,33,0,0,1,9.8-8.62A33.45,33.45,0,0,1,362,574.25Z" />
        </g>
        <g id="iav1"
           @click="clickRegion('ioav')"
           @mouseover="mouseOverRegion('ioav')"
           @mouseleave="mouseLeaveRegion('ioav')"
           style="cursor:pointer"
           data-name="图层 8">
          <g id="veins">
            <path class="cls-24"
                  d="M488.61,609.37a12.12,12.12,0,0,1-3-8.62c.45-5.23,2.65-12.79.41-16.12A1.51,1.51,0,1,1,488.6,583h0c2.8,4.34.72,11.83.07,17.2a8.92,8.92,0,0,0,2.22,7.32,1.5,1.5,0,0,1-2.28,1.85Z" />
            <path class="cls-24"
                  d="M467.2,623.41a1.5,1.5,0,0,1,1.23-2.65,5.09,5.09,0,0,0,4.63-2.28,17.66,17.66,0,0,1,6-4.51,1.5,1.5,0,0,1,1.3,2.63,14.68,14.68,0,0,0-4.93,3.75C472.53,624,468.38,624.35,467.2,623.41Z" />
            <path class="cls-24"
                  d="M486.22,601.9a14.13,14.13,0,0,1-2.12-3,6.2,6.2,0,0,0-3.63-3.35,1.5,1.5,0,0,1,1.06-2.81c4.46,1.64,4.63,4.74,6.7,7a1.5,1.5,0,0,1-2,2.13Z" />
            <path class="cls-24"
                  d="M510.55,619.73a3,3,0,0,0-.34-4.23l-.07-.06C507,613,507,610,508,604.82a1.5,1.5,0,0,1,1.77-1.18h0c3.28.7-1.75,6.3,2.19,9.45a6,6,0,0,1,1,8.37,1.5,1.5,0,0,1-2.46-1.74Z" />
            <path class="cls-24"
                  d="M488.5,648.35c-2.28-1.82-1.57-5.1-.37-7.74s.4-5.91-1.17-8.49a1.51,1.51,0,0,1,2.59-1.55c2.09,3.5,3,7.65,1.31,11.3-.53,1.14-1.46,3.87-.29,4.25C492.75,646.79,491.36,650.64,488.5,648.35Z" />
            <path class="cls-24"
                  d="M489.28,639.34a1.51,1.51,0,0,1,1.58-2.58,6.67,6.67,0,0,1,1.44,1c1.24,1,3.93-.37,4.52-.84a1.51,1.51,0,1,1,1.63,2.53c-.5.31-5,3.09-8.14.56A10.51,10.51,0,0,0,489.28,639.34Z" />
            <path class="cls-25"
                  d="M474.28,611.53c-2.93,1.41-5.07-1.74-3.34-4.73a3.47,3.47,0,0,1,4.49-1.81C477.67,606.34,476.89,610.23,474.28,611.53Z" />
            <path class="cls-26"
                  d="M474.28,611.53c-2.64-.67-2.41-5.21.62-6.74C477.54,605.46,477.32,610,474.28,611.53Z" />
            <path class="cls-25"
                  d="M469.55,648.37l-7.26-5.81a170.92,170.92,0,0,0,27-25.94c-5.86.06-13.39-1.65-17.93-5.28,3,2.37,7.27-3.2,4.6-5.94,5.92,4.14,13.95,3.46,20.91,1.78,5-6.6,9.15-12.11,11.64-16.14l6.74,5.4C508.08,607.9,492.2,630.64,469.55,648.37Z" />
            <path class="cls-26"
                  d="M472,646.45a5.57,5.57,0,0,1-.15-8.59A195.86,195.86,0,0,0,494.44,615c-4,.19-13.59-.29-16.08-3.15a7.38,7.38,0,0,0,1.38-4.49c5.92,2.08,11.49.83,14.25.61a44.94,44.94,0,0,0,7.08-1.23c4-5.32,7.46-9.88,10-13.62l4.16,3.33C508.33,607.49,493.43,629.1,472,646.45Z" />
            <polyline class="cls-25"
                      points="471.2 611.2 471.19 611.21 471.34 611.34" />
            <path class="cls-10"
                  d="M497.2,608.64a1.5,1.5,0,0,0,.85-.55c3.81-5.05,9-11.85,11.73-16.26a1.51,1.51,0,1,0-2.57-1.6c-2.64,4.26-7.9,11.17-11.25,15.6a55.7,55.7,0,0,1-5.5,1,8.79,8.79,0,0,1-1.83-5.85c.55-5.5,2.94-13.48,0-18a1.54,1.54,0,1,0-2.57,1.7h0c1.77,2.72.66,8.51.06,12a8.5,8.5,0,0,0-4.61-3.86,1.5,1.5,0,0,0-1.06,2.81c3.08,1.13,3,3.15,5.06,5.7a11.16,11.16,0,0,0,1.41,5.76,18.27,18.27,0,0,1-10.1-2.83c-3.48-3.15-9.09,1.44-7.83,6.11a4.42,4.42,0,0,0,1.26,2.1,22.53,22.53,0,0,0,5.85,3.31,14.42,14.42,0,0,0-3,2.78,5.09,5.09,0,0,1-4.63,2.28,1.5,1.5,0,0,0-.6,2.94,8,8,0,0,0,7.58-3.34,13.88,13.88,0,0,1,4.46-3.43,37.34,37.34,0,0,0,6.2,1.12,166,166,0,0,1-24.73,23.36,1.5,1.5,0,1,0,1.81,2.41,172,172,0,0,0,27.23-26.17,1.5,1.5,0,0,0-1.16-2.47,32.9,32.9,0,0,1-13.42-2.83,6,6,0,0,0,2.3-3.93C484.22,610.87,490.82,610.22,497.2,608.64Zm-22.52-2.34c.78.45.68,1.79.17,2.7-.76,1.31-2.54,2-2.93.52C471.43,607.75,473.47,605.63,474.68,606.31Z" />
            <path class="cls-10"
                  d="M498.57,639.5a1.51,1.51,0,1,0-1.63-2.53c-.65.42-3.35,1.78-4.52.84a5.47,5.47,0,0,0-.56-.45,14,14,0,0,0-1.62-5.74,220.7,220.7,0,0,0,17.4-21,6.5,6.5,0,0,0,2.49,4.82,3,3,0,0,1,.47,4.22l-.06.07a1.5,1.5,0,1,0,2.46,1.74,6,6,0,0,0-1-8.37c-1.62-1.29-2-2.57-1.07-7.39,2.23-3.22,4.1-6,5.57-8.47a1.51,1.51,0,1,0-2.57-1.6c-7.33,11.79-23,34.17-45.31,51.57a1.5,1.5,0,0,0,1.84,2.36,173,173,0,0,0,17.38-15.66c2.88,6.77-2.62,8.71-.36,13.17a3.74,3.74,0,0,0,2.43,1.94,1.5,1.5,0,0,0,.68-2.92c-1.53-.49.4-4.32.75-5.51C494.33,642,498.06,639.74,498.57,639.5Z" />
          </g>
        </g>
        <g id="aim1"
           @click="clickRegion('aiam')"
           @mouseover="mouseOverRegion('aiam')"
           @mouseleave="mouseLeaveRegion('aiam')"
           style="cursor:pointer"
           data-name="图层 7">
          <circle class="cls-27"
                  cx="610.58"
                  cy="580.19"
                  r="29.8" />
          <path class="cls-28"
                d="M627.66,563.11l-8.37,1-5.34-5.34-6.61,6.61,7,7-.56-.25L612.63,571l-3.87-.22-7.7-7.7-7.56,7.56,7.7,7.7.22,3.87,1.16,1.16.25.56-7-7-6.61,6.61,5.34,5.34-1,8.37,12.35,12.35A29.82,29.82,0,0,0,640,575.46l-12.35-12.35Z" />
          <path class="cls-29"
                d="M618.77,577.53a8.56,8.56,0,0,0-.52-1.26,2.84,2.84,0,0,0-3.76-3.76,8.56,8.56,0,0,0-1.26-.52,2.84,2.84,0,0,0-2.66-1.84l-4,10,4,10a2.84,2.84,0,0,0,2.66-1.84,8.56,8.56,0,0,0,1.26-.52,2.84,2.84,0,0,0,3.76-3.76,8.56,8.56,0,0,0,.52-1.26,2.84,2.84,0,0,0,0-5.32Z" />
          <path class="cls-30"
                d="M607.92,572a8.56,8.56,0,0,0-1.26.52,2.84,2.84,0,0,0-3.76,3.76,8.56,8.56,0,0,0-.52,1.26,2.84,2.84,0,0,0,0,5.32,8.56,8.56,0,0,0,.52,1.26,2.84,2.84,0,0,0,3.76,3.76,8.57,8.57,0,0,0,1.26.52,2.84,2.84,0,0,0,2.66,1.84V570.15a2.84,2.84,0,0,0-2.66,1.84Z" />
          <path class="cls-27"
                d="M611.91,581h2.67v2.67h-2.67Z" />
          <path class="cls-29"
                d="M609.24,579.4h-2.67v-2.67h2.67Z" />
          <path class="cls-30"
                d="M610.58,557.37l-2.34,4.68,2.34,4.68a4.68,4.68,0,0,0,0-9.36Z" />
          <path class="cls-31"
                d="M605.9,562.05a4.68,4.68,0,0,0,4.68,4.68v-9.36A4.68,4.68,0,0,0,605.9,562.05Z" />
          <path class="cls-30"
                d="M610.58,593.65l-2.34,4.68,2.34,4.68a4.68,4.68,0,0,0,0-9.36Z" />
          <path class="cls-31"
                d="M605.9,598.33a4.68,4.68,0,0,0,4.68,4.68v-9.36A4.68,4.68,0,0,0,605.9,598.33Z" />
          <circle class="cls-30"
                  cx="628.71"
                  cy="580.19"
                  r="4.68" />
          <circle class="cls-31"
                  cx="592.44"
                  cy="580.19"
                  r="4.68" />
          <circle class="cls-29"
                  cx="623.87"
                  cy="593.49"
                  r="5.35" />
          <circle class="cls-30"
                  cx="597.28"
                  cy="566.89"
                  r="5.35" />
          <circle class="cls-29"
                  cx="623.87"
                  cy="566.89"
                  r="5.35" />
          <circle class="cls-30"
                  cx="597.28"
                  cy="593.49"
                  r="5.35" />
        </g>
        <g id="tpi1"
           @click="clickRegion('tpi')"
           @mouseover="mouseOverRegion('tpi')"
           @mouseleave="mouseLeaveRegion('tpi')"
           style="cursor:pointer"
           data-name="图层 6">
          <path class="cls-32"
                d="M708.48,470.8v5.76l0,7.56,0,7.68v4.08a29.64,29.64,0,0,1-39.39,0l0-17.68v-7.39a12.87,12.87,0,0,1,2.84-7.93,10.81,10.81,0,0,1,3.53-2.93c1-.49,2.37-1.07,3.85-1.66s3-1.13,4.26-1.63c0,.2.64-2.22.64-2.22-1.33-1.17-3.6-4.71-4.58-8.88a29.78,29.78,0,0,1,17.95-.16,17,17,0,0,1-4.11,9s.64,2.42.64,2.22c2.65,1,6.19,2.32,8.11,3.29a10.72,10.72,0,0,1,3.37,2.73,12.89,12.89,0,0,1,3,8.12Z" />
          <path class="cls-33"
                d="M688.73,478.65c-2.18,1.38-5.29,1.19-6.07-1.54s-3.31-1.94-3.31.39-2.64,4-4.19,4.18v-2.53s-2,.88-2.91-.88-3.26.58-3.26-.1V470.8a12.87,12.87,0,0,1,2.84-7.93,2.38,2.38,0,0,1,1.84.43c1.3,1.36,1.88,1.82,2.89,1.56s2.24.45,2.82-1,1.85-2.34,3.6-1.17,3.21-.29,4.18,2,1.65,3.56.39,5-.88,2.88,1.65,3.93,1.73,3.54-.45,4.92Z" />
          <path class="cls-33"
                d="M708.47,476.56l0,7.56,0,7.68a2.83,2.83,0,0,1-2.49-.33,2.42,2.42,0,0,0-3.19,0v3.29c0,1.1-1.9,2.2-3.75,2.5s-2.92-1.07-5.35-1.37-4.67,2.16-8.29-.66-.36-4.09-1.31-6.52.71-3.08,2.9-2.94c1.41.09,2.72-.73,3.94-2.16s2.09-1.24,4.88-1.1.91-1.36,2.79-3a3.7,3.7,0,0,1,4.15-.39l.05-2.07c.38-.2,1.12,1.43,3.32.06a3.36,3.36,0,0,1,2.4-.5Z" />
          <path class="cls-10"
                d="M688.77,457.23h-.13a7.6,7.6,0,0,1-5-2.39.54.54,0,0,1,.81-.72,6.6,6.6,0,0,0,4.23,2,5.79,5.79,0,0,0,4.26-2,.54.54,0,0,1,.78.75h0a6.88,6.88,0,0,1-4.94,2.38Z" />
          <path class="cls-10"
                d="M709.28,452.93h-.14a.54.54,0,0,1,0-1.08h.14a.54.54,0,0,1,0,1.08Zm-2.84,0h-1.35a.54.54,0,0,1,0-1.08h1.35a.54.54,0,0,1,0,1.08Zm-4.05,0H701a.54.54,0,0,1,0-1.08h1.35a.54.54,0,0,1,0,1.08Z" />
          <path class="cls-10"
                d="M714.69,460.81h-1.35a.54.54,0,0,1,0-1.08h1.35a.54.54,0,0,1,0,1.08Zm-4.05,0h-1.35a.54.54,0,0,1,0-1.08h1.35a.54.54,0,0,1,0,1.08Z" />
          <path class="cls-10"
                d="M718.1,470.34H717a.54.54,0,0,1,0-1.08h1.14a.54.54,0,0,1,0,1.08Zm-3.84,0h-1.35a.54.54,0,0,1,0-1.08h1.35a.54.54,0,0,1,0,1.08Z" />
          <path class="cls-10"
                d="M718,479.19h-1a.54.54,0,0,1,0-1.08h1a.54.54,0,0,1,0,1.08Zm-3.69,0h-1.35a.54.54,0,1,1,0-1.08h1.35a.54.54,0,0,1,0,1.08Z" />
          <path class="cls-10"
                d="M713.56,487.66h-1.35a.54.54,0,0,1,0-1.08h1.35a.54.54,0,0,1,0,1.08Z" />
          <path class="cls-10"
                d="M677.69,452.93h-1.35a.54.54,0,0,1,0-1.08h1.35a.54.54,0,1,1,0,1.08Zm-4.05,0h-1.35a.54.54,0,1,1,0-1.08h1.35a.54.54,0,0,1,0,1.08Zm-4.05,0H669a.54.54,0,1,1,0-1.08h.62a.54.54,0,0,1,0,1.08Z" />
          <path class="cls-10"
                d="M669.61,460.81h-1.35a.54.54,0,1,1,0-1.08h1.35a.54.54,0,0,1,0,1.08Zm-4.05,0h-1.34a.54.54,0,0,1,0-1.08h1.35a.54.54,0,0,1,0,1.08Z" />
          <path class="cls-10"
                d="M665.54,470.34h-1.35a.54.54,0,1,1,0-1.08h1.35a.54.54,0,1,1,0,1.08Zm-4.05,0h-1.35a.54.54,0,0,1,0-1.08h1.35a.54.54,0,1,1,0,1.08Z" />
          <path class="cls-10"
                d="M665.54,479.19h-1.35a.54.54,0,1,1,0-1.08h1.35a.54.54,0,0,1,0,1.08Zm-4.05,0h-1.35a.54.54,0,1,1,0-1.08h1.35a.54.54,0,1,1,0,1.08h0Z" />
          <path class="cls-10"
                d="M666.41,487.66h-1.35a.54.54,0,0,1,0-1.08h1.35a.54.54,0,1,1,0,1.08Z" />
          <path class="cls-10"
                d="M669,496.41a.54.54,0,0,1-.54-.54l-.06-25.07a13.09,13.09,0,0,1,6.67-11.34c.87-.44,2.14-1,3.9-1.68,1.36-.53,2.78-1.07,4-1.55.1-.33.27-1,.45-1.62a20.73,20.73,0,0,1-4.5-8.93.54.54,0,1,1,1-.27v0a18.84,18.84,0,0,0,4.41,8.6.54.54,0,0,1,.16.54s-.15.56-.3,1.12c-.08.28-.16.57-.22.78s-.21.7-.57.73c-1.29.49-2.75,1-4.13,1.58-1.72.69-3,1.22-3.81,1.64a12,12,0,0,0-6.07,10.37l.06,25.08a.54.54,0,0,1-.54.54h0Z" />
          <path class="cls-10"
                d="M708.42,496.41a.54.54,0,0,1-.54-.54h0l.06-25.07a12.39,12.39,0,0,0-2.87-7.78,10.11,10.11,0,0,0-3.2-2.59c-1.8-.91-5-2.13-7.66-3.11l-.27-.1c-.37,0-.48-.4-.57-.73s-.14-.49-.22-.78c-.15-.56-.3-1.12-.3-1.12a.54.54,0,0,1,.11-.48,16.46,16.46,0,0,0,4-8.78.54.54,0,0,1,1.06.19,17.47,17.47,0,0,1-4,9.06c.17.66.36,1.33.46,1.66l.18.07c2.63,1,5.91,2.22,7.76,3.16a11.18,11.18,0,0,1,3.54,2.87,13.51,13.51,0,0,1,3.12,8.47L709,495.88a.54.54,0,0,1-.54.53Z" />
          <path class="cls-10"
                d="M675.16,500.62a.54.54,0,0,1-.54-.54V471.44a.54.54,0,0,1,1.08,0v28.65a.54.54,0,0,1-.54.54Z" />
          <path class="cls-10"
                d="M702.75,500.62a.54.54,0,0,1-.54-.54V471.44a.54.54,0,0,1,1.08,0h0v28.65A.54.54,0,0,1,702.75,500.62Z" />
          <path class="cls-10"
                d="M682.46,467.87a.54.54,0,0,1-.34-.12l-.71-.58a.54.54,0,0,1,.69-.84l.71.58a.54.54,0,0,1-.34,1Z" />
          <path class="cls-10"
                d="M678.05,470.07a.54.54,0,0,1-.44-.86l.65-.91a.54.54,0,0,1,.88.63h0l-.65.91A.54.54,0,0,1,678.05,470.07Z" />
          <path class="cls-10"
                d="M682.79,473.11a.54.54,0,0,1-.52-.39l-.32-1.14a.54.54,0,0,1,1-.3l.32,1.14a.54.54,0,0,1-.37.67l-.15,0Z" />
          <path class="cls-10"
                d="M671.83,472.55a.54.54,0,0,1-.45-.84l.58-.86a.54.54,0,1,1,.89.61h0l-.58.86A.54.54,0,0,1,671.83,472.55Z" />
          <path class="cls-10"
                d="M672.93,467.87a.54.54,0,0,1-.4-.18l-.52-.58a.54.54,0,0,1,.81-.72l.52.58a.54.54,0,0,1-.4.9Z" />
          <path class="cls-10"
                d="M694.52,486.3a.54.54,0,0,1-.3-.09l-.71-.47a.54.54,0,0,1,.6-.9l.71.47a.54.54,0,0,1-.3,1Z" />
          <path class="cls-10"
                d="M699.06,485.83a.54.54,0,0,1-.42-.87l.71-.91a.54.54,0,1,1,.85.67h0l-.71.91A.54.54,0,0,1,699.06,485.83Z" />
          <path class="cls-10"
                d="M690.75,489.07a.54.54,0,0,1-.19,0l-1-.39a.54.54,0,1,1,.38-1l1,.39a.54.54,0,0,1-.19,1Z" />
          <path class="cls-10"
                d="M696.47,490.37a.54.54,0,0,1-.54-.54V489a.54.54,0,1,1,1.08,0h0v.78A.54.54,0,0,1,696.47,490.37Z" />
          <path class="cls-10"
                d="M687.2,493.48a.54.54,0,0,1-.22-1l1.17-.52a.54.54,0,0,1,.44,1l-1.17.52a.54.54,0,0,1-.22.05Z" />
          <path class="cls-10"
                d="M693.81,493a.54.54,0,0,1-.48-.3l-.45-.91a.54.54,0,0,1,1-.48l.45.91a.54.54,0,0,1-.48.78Z" />
          <path class="cls-10"
                d="M698.74,494.39a.54.54,0,0,1-.43-.86l.69-.91a.54.54,0,1,1,.86.65l-.69.91A.54.54,0,0,1,698.74,494.39Z" />
          <path class="cls-10"
                d="M706.07,481.68a.54.54,0,0,1-.33-.11l-.84-.65a.54.54,0,1,1,.64-.87h0l.84.65a.54.54,0,0,1-.33,1Z" />
          <path class="cls-10"
                d="M705.22,487.13a.54.54,0,0,1-.5-.74l.42-1.06a.54.54,0,0,1,1,.4h0l-.42,1.06A.54.54,0,0,1,705.22,487.13Z" />
          <path class="cls-10"
                d="M685.51,476.1a.54.54,0,0,1-.11-1.07l1.24-.26a.54.54,0,1,1,.24,1.05h0l-1.24.26Z" />
          <path class="cls-10"
                d="M677.14,475.84a.54.54,0,0,1-.46-.82l.58-1a.54.54,0,0,1,.93.55h0l-.58,1A.54.54,0,0,1,677.14,475.84Z" />
          <path class="cls-10"
                d="M673.32,476.43a.54.54,0,0,1-.29-.09l-.91-.58a.54.54,0,1,1,.57-.92h0l.91.58a.54.54,0,0,1-.29,1Z" />
          <path class="cls-10"
                d="M675.16,482.23a.54.54,0,0,1-.54-.54v-1.81a2.52,2.52,0,0,1-2.85-1.35c-.25-.5-.66-.49-1.8,0-.48.23-.86.41-1.22.18a.65.65,0,0,1-.3-.56l0-7.39a13.35,13.35,0,0,1,3-8.27.54.54,0,0,1,.39-.2,2.79,2.79,0,0,1,2.26.6c1.28,1.35,1.68,1.58,2.36,1.41a3.85,3.85,0,0,1,1.14-.07c.75,0,1.07,0,1.31-.58a3.14,3.14,0,0,1,1.86-2,2.93,2.93,0,0,1,2.54.56,3.12,3.12,0,0,0,1.71.46,2.59,2.59,0,0,1,2.68,1.82l.22.53c.85,2,1.46,3.45.08,5.06a1.71,1.71,0,0,0-.54,1.45c.14.58.82,1.15,2,1.63a2.76,2.76,0,0,1,1.9,2.27,4.19,4.19,0,0,1-2.26,3.61,5.36,5.36,0,0,1-4.65.65,3.61,3.61,0,0,1-2.23-2.49c-.26-.89-.75-1.4-1.28-1.33s-1,.63-1,1.57c0,2.75-3,4.51-4.66,4.72h-.07Zm0-3.61a.54.54,0,0,1,.54.54V481c1.31-.44,3.11-1.74,3.11-3.5a2.48,2.48,0,0,1,1.9-2.64c.82-.12,2,.36,2.47,2.1a2.56,2.56,0,0,0,1.58,1.79,4.31,4.31,0,0,0,3.68-.55,3.25,3.25,0,0,0,1.76-2.61c0-.58-.46-1-1.24-1.36-1.51-.63-2.4-1.43-2.63-2.38a2.7,2.7,0,0,1,.77-2.4c.9-1.05.64-1.84-.25-3.94l-.23-.54c-.45-1.08-.91-1.1-1.74-1.16a4.16,4.16,0,0,1-2.24-.64,2,2,0,0,0-1.62-.42,2.21,2.21,0,0,0-1.18,1.35,2,2,0,0,1-2.36,1.26,3,3,0,0,0-.82,0c-1.37.35-2.19-.41-3.41-1.71-.11-.11-.4-.29-1.18-.27a12.23,12.23,0,0,0-2.56,7.39l0,6.79c.74-.35,2.42-1.12,3.21.46.62,1.25,2.05.69,2.21.62a.55.55,0,0,1,.21-.05Z" />
          <path class="cls-10"
                d="M698.49,497.83a5.88,5.88,0,0,1-2.39-.65,8.74,8.74,0,0,0-2.51-.78,6,6,0,0,0-2.22.3,6.35,6.35,0,0,1-6.33-1.08c-2.54-2-2.06-3.41-1.63-4.67a2.78,2.78,0,0,0,.15-2.06,2.7,2.7,0,0,1,.07-2.67c.57-.77,1.7-1.11,3.37-1,1.14.07,2.32-.59,3.49-2s2.32-1.45,4.61-1.33l.71,0c.79,0,1-.08,1.07-.13a1.25,1.25,0,0,0,.15-.51,3.47,3.47,0,0,1,1.18-2.27,4.05,4.05,0,0,1,4-.79l0-1.29a.54.54,0,0,1,.29-.47.93.93,0,0,1,1,.2c.43.29,1,.69,2.3-.11a3.88,3.88,0,0,1,2.78-.57.54.54,0,0,1,.45.53l0,15.24a.54.54,0,0,1-.4.52,3.33,3.33,0,0,1-3-.41,1.9,1.9,0,0,0-2.33-.18v3c0,1.48-2.14,2.7-4.21,3a3.82,3.82,0,0,1-.59,0Zm-5.28-2.53a4,4,0,0,1,.51,0,9.8,9.8,0,0,1,2.8.86,4.14,4.14,0,0,0,2.39.53c1.82-.29,3.3-1.31,3.3-2v-3.29a.54.54,0,0,1,.16-.39,3,3,0,0,1,3.89,0,2.09,2.09,0,0,0,1.63.33l0-14.31a2.93,2.93,0,0,0-1.58.46,2.87,2.87,0,0,1-3.08.33l0,1.24a.54.54,0,0,1-.81.46,3.14,3.14,0,0,0-3.52.32,2.4,2.4,0,0,0-.84,1.64c-.18,1.09-.59,1.63-2.34,1.55l-.72,0c-2.2-.11-2.8-.15-3.73.95-1.41,1.65-2.89,2.44-4.38,2.35-1.24-.08-2.1.12-2.43.56s-.22.89.07,1.64a3.77,3.77,0,0,1-.13,2.8c-.38,1.15-.66,2,1.27,3.49,2.2,1.72,3.75,1.31,5.4.88a8.42,8.42,0,0,1,2.12-.36Z" />
        </g>
        <g id="aid1"
           @click="clickRegion('aid')"
           @mouseover="mouseOverRegion('aid')"
           @mouseleave="mouseLeaveRegion('aid')"
           style="cursor:pointer"
           data-name="图层 5">
          <path class="cls-34"
                d="M689.58,374a7.26,7.26,0,0,1-2.63-.49A28.34,28.34,0,0,1,668.84,347V335a6.15,6.15,0,0,1,6.14-6.14h29.2a6.15,6.15,0,0,1,6.14,6.14v12a28.34,28.34,0,0,1-18.12,26.43A7.26,7.26,0,0,1,689.58,374Z" />
          <path class="cls-35"
                d="M689.58,372a5.27,5.27,0,0,1-1.91-.36A26.35,26.35,0,0,1,670.83,347V335a4.16,4.16,0,0,1,4.15-4.15h29.2a4.16,4.16,0,0,1,4.15,4.15v12a26.35,26.35,0,0,1-16.84,24.58A5.26,5.26,0,0,1,689.58,372Z" />
          <path class="cls-36"
                d="M675,333.11A1.88,1.88,0,0,0,673.1,335v12a24.08,24.08,0,0,0,15.39,22.46,3,3,0,0,0,2.18,0A24.07,24.07,0,0,0,706.06,347V335a1.88,1.88,0,0,0-1.88-1.88H675Z" />
          <path class="cls-37"
                d="M706.06,335v12a24.07,24.07,0,0,1-15.39,22.45,3,3,0,0,1-2.18,0l-.55-.22A24.07,24.07,0,0,0,702.78,347V335a1.88,1.88,0,0,0-1.88-1.88h3.28A1.88,1.88,0,0,1,706.06,335Z" />
          <path class="cls-38"
                d="M695.8,349.9h-3.19v-3.19a1.42,1.42,0,0,0-1.42-1.42H688a1.42,1.42,0,0,0-1.42,1.42v3.19h-3.19a1.42,1.42,0,0,0-1.42,1.42v3.22a1.42,1.42,0,0,0,1.42,1.42h3.19v3.19a1.42,1.42,0,0,0,1.42,1.42h3.22a1.42,1.42,0,0,0,1.42-1.42V356h3.19a1.42,1.42,0,0,0,1.42-1.42v-3.22A1.42,1.42,0,0,0,695.8,349.9Z" />
          <path class="cls-39"
                d="M724.2,357.9a3.13,3.13,0,1,1-3.13-3.13A3.13,3.13,0,0,1,724.2,357.9Z" />
          <path class="cls-40"
                d="M724.2,357.9a3.13,3.13,0,0,1-3.13,3.13,3.09,3.09,0,0,1-1.28-.27,3.13,3.13,0,0,0,0-5.7,3.09,3.09,0,0,1,1.28-.27A3.13,3.13,0,0,1,724.2,357.9Z" />
          <path class="cls-41"
                d="M667,375.75a3.13,3.13,0,1,1-3.13-3.13A3.13,3.13,0,0,1,667,375.75Z" />
          <path class="cls-42"
                d="M667,375.75a3.13,3.13,0,0,1-3.13,3.13,3.09,3.09,0,0,1-1.28-.27,3.13,3.13,0,0,0,0-5.7,3.09,3.09,0,0,1,1.28-.27A3.13,3.13,0,0,1,667,375.75Z" />
          <path class="cls-37"
                d="M669,325.91a3.13,3.13,0,1,1-3.13-3.13A3.13,3.13,0,0,1,669,325.91Z" />
          <path class="cls-43"
                d="M669,325.91a3.12,3.12,0,0,1-4.4,2.85,3.13,3.13,0,0,0,0-5.7,3.12,3.12,0,0,1,4.4,2.85Z" />
          <path class="cls-44"
                d="M699.38,336.69a4.64,4.64,0,1,1-4.64-4.64A4.64,4.64,0,0,1,699.38,336.69Z" />
          <path class="cls-45"
                d="M699.38,336.69a4.64,4.64,0,0,1-4.64,4.64,4.59,4.59,0,0,1-1.9-.41,4.64,4.64,0,0,0,0-8.46,4.59,4.59,0,0,1,1.9-.41A4.64,4.64,0,0,1,699.38,336.69Z" />
          <path class="cls-10"
                d="M683.36,357h2.12v2.12a2.49,2.49,0,0,0,2.49,2.49h3.22a2.49,2.49,0,0,0,2.49-2.49V357h2.12a2.49,2.49,0,0,0,2.49-2.49v-3.22a2.49,2.49,0,0,0-2.49-2.49h-2.12v-2.12a2.49,2.49,0,0,0-2.49-2.49H688a2.49,2.49,0,0,0-2.49,2.49v2.12h-2.12a2.49,2.49,0,0,0-2.49,2.49v3.22A2.49,2.49,0,0,0,683.36,357Zm-.36-5.7a.36.36,0,0,1,.36-.36h3.19a1.07,1.07,0,0,0,1.07-1.07v-3.19a.36.36,0,0,1,.36-.36h3.22a.36.36,0,0,1,.36.36v3.19a1.07,1.07,0,0,0,1.07,1.07h3.19a.36.36,0,0,1,.36.36v3.22a.36.36,0,0,1-.36.36h-3.19a1.07,1.07,0,0,0-1.07,1.07v3.19a.36.36,0,0,1-.36.36H688a.36.36,0,0,1-.36-.36V356a1.07,1.07,0,0,0-1.07-1.07h-3.19a.36.36,0,0,1-.36-.36Z" />
          <path class="cls-10"
                d="M725.95,351.4c0-3.62-2.67-7-7.71-9.74q-1.11-.61-2.35-1.16a29,29,0,0,0,1.41-4.76c.87-4.41.18-7.88-2-10.06-1.94-1.94-5-2.71-8.71-2.22a34.64,34.64,0,0,0-11.8,4.32H684.36a46.45,46.45,0,0,0-5-2.42c-3.92-1.6-7.35-2.26-10.19-2a4.19,4.19,0,0,0-6.91,4.72c-1,2.39-1,5.49,0,9.21a31.39,31.39,0,0,0,1,3.19c-6.5,2.89-10.07,6.74-10.07,10.9s3.68,8.07,10.07,10.91a21,21,0,0,0-1.67,9.92,4.19,4.19,0,1,0,5.06,6.64,11,11,0,0,0,3.74.6c4.21,0,9.59-1.83,15.44-5.31l.72.29a8.35,8.35,0,0,0,6,0l.72-.29c5.91,3.51,11.24,5.31,15.41,5.31a9,9,0,0,0,6.58-2.36c2.94-2.94,3.14-8.18.59-14.82q1.3-.58,2.46-1.22a4.19,4.19,0,0,0,6.29-5.39A7.91,7.91,0,0,0,725.95,351.4Zm-8.73-7.87c4.26,2.32,6.6,5.11,6.6,7.87a5.67,5.67,0,0,1-.79,2.8,4.19,4.19,0,0,0-5.91,5.12q-1,.53-2.06,1a54.23,54.23,0,0,0-4.22-7.61,29.39,29.39,0,0,0,.46-3.35,53.28,53.28,0,0,0,3.77-6.9Q716.2,343,717.22,343.53Zm-4.12,17.61a50.5,50.5,0,0,1-6.47,1.94,29.21,29.21,0,0,0,3.5-7.51A49.77,49.77,0,0,1,713.09,361.14Zm-12.45-20.8-.91-.89a5.73,5.73,0,0,0,.4-.89c1.67.22,3.29.49,4.86.81V345C703.63,343.43,702.18,341.87,700.65,340.34Zm-26.48-3.15V335a.82.82,0,0,1,.81-.82h2.77a1.07,1.07,0,0,0,0-2.13H675A3,3,0,0,0,672,335v2.66q-1.09.25-2.13.54V335a5.08,5.08,0,0,1,5.08-5.08h8.84q1.7,1,3.46,2.13h-4.61a1.07,1.07,0,1,0,0,2.13h7a5.65,5.65,0,0,0-.51,1.58A80,80,0,0,0,674.17,337.19Zm20.58-4.07a3.57,3.57,0,1,1-3.57,3.57A3.58,3.58,0,0,1,694.75,333.12ZM705,337.19q-2.2-.43-4.55-.74a5.67,5.67,0,0,0-.58-2.27h4.32a.82.82,0,0,1,.82.82Zm2.13,9.84v-7.19q1.09.26,2.13.56V347a27.68,27.68,0,0,1-.18,3.14q-.94-1.29-2-2.58C707.12,347.4,707.13,347.22,707.13,347Zm4.26-6q.87.29,1.7.6-.74,1.65-1.7,3.39Zm-4.53-15.48c3.89-.51,5.91.6,6.93,1.61,2.31,2.31,2.27,6.87.12,12.5q-1.21-.46-2.52-.88V335a7.22,7.22,0,0,0-7.21-7.21h-4.62A27.27,27.27,0,0,1,706.86,325.58Zm-2.68,4.34a5.08,5.08,0,0,1,5.08,5.08v3.19q-1-.28-2.13-.54V335a3,3,0,0,0-2.95-2.95H698a5.68,5.68,0,0,0-6.6,0H691q-1.55-1.13-3.1-2.13Zm-24.56-2.13H675a7.22,7.22,0,0,0-7.21,7.21v3.82q-1.3.41-2.52.88a29.41,29.41,0,0,1-1-2.93,13.68,13.68,0,0,1-.33-7.1,4.19,4.19,0,0,0,6.06-3.75,4.24,4.24,0,0,0,0-.45A22.71,22.71,0,0,1,679.62,327.78Zm-7.08,35.3a50.18,50.18,0,0,1-6.48-1.94,50.08,50.08,0,0,1,3-5.56A29.22,29.22,0,0,0,672.54,363.08Zm-4.77-18c-.64-1.15-1.2-2.29-1.7-3.39q.83-.32,1.7-.61Zm-1.94-21.2a2.06,2.06,0,1,1-2.06,2.06A2.06,2.06,0,0,1,665.83,323.85Zm-5.22,34.63c-2.4-1.51-5.26-4-5.26-7.08s3.18-6.44,8.76-8.93a53.44,53.44,0,0,0,3.76,6.9,29.49,29.49,0,0,0,.46,3.35,54.11,54.11,0,0,0-4.22,7.61A28.07,28.07,0,0,1,660.61,358.48Zm3.27,19.33a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,663.88,377.81Zm4-.78a4.19,4.19,0,0,0-4-5.47h-.2a19.44,19.44,0,0,1,1.56-8.45,55.64,55.64,0,0,0,9.19,2.54,29.28,29.28,0,0,0,9.07,7.4C677.17,376.6,671.48,378,667.87,377Zm45.92-1.42c-3,3-9.91,2.05-18.13-2.55a29.29,29.29,0,0,0,4.15-2.65,1.07,1.07,0,1,0-1.29-1.69,27.23,27.23,0,0,1-6.7,3.75,6.22,6.22,0,0,1-4.48,0A27.27,27.27,0,0,1,669.9,347V340.4q1-.3,2.13-.56V347a24.87,24.87,0,0,0,2.74,11.41,1.07,1.07,0,0,0,1.9-1,22.75,22.75,0,0,1-2.5-10.44v-7.67a77.5,77.5,0,0,1,15-1.47,5.7,5.7,0,0,0,9.21,3.2l.76.75A83.08,83.08,0,0,1,705,348.3a23,23,0,0,1-14.67,20.19,2,2,0,0,1-1.41,0,23.07,23.07,0,0,1-9.6-7,1.07,1.07,0,0,0-1.66,1.34,25.2,25.2,0,0,0,10.49,7.65,4.08,4.08,0,0,0,2.95,0,25.15,25.15,0,0,0,15.8-19.74q.9,1.21,1.71,2.41a27.08,27.08,0,0,1-4.2,9.47,27.64,27.64,0,0,1-2.35,2.92,1.07,1.07,0,0,0,1.57,1.45c.4-.43.78-.87,1.15-1.33a55.41,55.41,0,0,0,9.18-2.55C716.09,368.81,716.06,373.34,713.79,375.61ZM721.07,360a2.06,2.06,0,1,1,2.06-2.06A2.06,2.06,0,0,1,721.07,360Z" />
        </g>
        <g id="egs1"
           @click="clickRegion('egs')"
           @mouseover="mouseOverRegion('egs')"
           @mouseleave="mouseLeaveRegion('egs')"
           style="cursor:pointer"
           data-name="图层 4">
          <g id="Layer_1">
            <g id="_301960808"
               data-name=" 301960808">
              <path id="_301956584"
                    data-name=" 301956584"
                    class="cls-50"
                    d="M614.42,276A26.6,26.6,0,1,1,641,249.39,26.63,26.63,0,0,1,614.42,276Zm0-51.93a25.33,25.33,0,1,0,25.33,25.33A25.36,25.36,0,0,0,614.42,224.06Z" />
              <path id="_301956776"
                    data-name=" 301956776"
                    class="cls-50"
                    d="M614.42,269.07h0a19.68,19.68,0,0,1-16.47-30.46.64.64,0,0,1,1-.1l26.36,26.36a.64.64,0,0,1-.1,1,19.59,19.59,0,0,1-10.78,3.21ZM598.6,240a18.47,18.47,0,0,0,2.81,22.42,18.28,18.28,0,0,0,13,5.39h0a18.33,18.33,0,0,0,9.41-2.58L598.6,240Z" />
              <path id="_301957664"
                    data-name=" 301957664"
                    class="cls-50"
                    d="M630.35,260.45a.64.64,0,0,1-.45-.19L603.54,233.9a.64.64,0,0,1,.1-1,19.68,19.68,0,0,1,27.25,27.25.64.64,0,0,1-.47.28h-.07ZM605,233.57l25.23,25.23a18.47,18.47,0,0,0-2.81-22.42A18.42,18.42,0,0,0,605,233.57Z" />
              <path id="_301957808"
                    data-name=" 301957808"
                    class="cls-50"
                    d="M590.14,276.22a3.83,3.83,0,1,1,3.83-3.83A3.84,3.84,0,0,1,590.14,276.22Zm0-6.39a2.56,2.56,0,1,0,2.56,2.56A2.56,2.56,0,0,0,590.14,269.83Z" />
              <path id="_301958624"
                    data-name=" 301958624"
                    class="cls-50"
                    d="M638.69,230.86a5.11,5.11,0,1,1,5.11-5.11A5.12,5.12,0,0,1,638.69,230.86Zm0-8.94a3.83,3.83,0,1,0,3.83,3.83A3.84,3.84,0,0,0,638.69,221.92Z" />
            </g>
            <path class="cls-51"
                  d="M614.42,224.06a25.33,25.33,0,1,0,25.33,25.33A25.36,25.36,0,0,0,614.42,224.06Zm15.48,36.21L603.54,233.9a.64.64,0,0,1,.1-1,19.68,19.68,0,0,1,27.25,27.25.64.64,0,0,1-.47.28h-.07a.64.64,0,0,1-.45-.19Zm-31-21.76,26.36,26.36a.64.64,0,0,1-.1,1,19.68,19.68,0,0,1-27.25-27.25.64.64,0,0,1,1-.1Z" />
            <path class="cls-12"
                  d="M592.7,272.39a2.56,2.56,0,1,0-2.56,2.56A2.56,2.56,0,0,0,592.7,272.39Z" />
            <path class="cls-12"
                  d="M634.86,225.75a3.83,3.83,0,1,0,3.83-3.83A3.84,3.84,0,0,0,634.86,225.75Z" />
          </g>
        </g>
        <g id="titles"
           data-name="titles">
          <text class="cls-3"
                transform="translate(391.01 112.93)">Sustaining proliferative <tspan x="63.02"
                   y="21.6">signaling</tspan></text><text class="cls-3"
                transform="translate(636.4 167.91)">Evading growth <tspan x="15.98"
                   y="21.6">suppressors</tspan></text><text class="cls-3"
                transform="translate(746.63 322.46)">Avoiding immune <tspan x="29"
                   y="21.6">destruction</tspan></text><text class="cls-3"
                transform="translate(750.41 490.2)">
            <tspan class="cls-4">T</tspan>
            <tspan x="10.67"
                   y="0">umor-promoting </tspan>
            <tspan x="21.82"
                   y="21.6">inflammation</tspan>
          </text><text class="cls-3"
                transform="translate(654.72 641.84)">Activating invasion <tspan x="29.49"
                   y="21.6">&amp; metastasis</tspan></text><text class="cls-3"
                transform="translate(396.01 700.62)">Inducing or accessing <tspan x="47.5"
                   y="21.6">vasculature</tspan></text><text class="cls-3"
                transform="translate(174.69 641.84)">Genome instability <tspan x="36.02"
                   y="21.6">&amp; mutation</tspan></text><text class="cls-3"
                transform="translate(108.02 490.2)">Resisting cell <tspan x="36.52"
                   y="21.6">death</tspan></text><text class="cls-3"
                transform="translate(60.42 322.46)">Deregulating cellular <tspan x="41.51"
                   y="21.6">metabolism</tspan></text><text class="cls-3"
                transform="translate(172.64 167.91)">Unlocking phenotypic <tspan x="57.49"
                   y="21.6">plasticity</tspan></text><text class="cls-3 cls-5"
                transform="translate(434.46 393.44)">Hallmarks <tspan x="46.04"
                   y="28.8">of </tspan>
            <tspan x="20.02"
                   y="57.6">Cancer</tspan>
          </text>
        </g>
      </svg>
    </div>
    <v-row dense
           class="mx-16">
      <v-col cols="12">
        <v-alert v-show="bio_func_selected != '-'"
                 color="info"
                 text
                 dense>
          <v-btn small
                 color="error"
                 class="mx-1"
                 @click="refreshHallMark()"
                 v-show="bio_func_selected != '-'">
            <v-icon left>mdi-refresh</v-icon>
            Clear
          </v-btn>
          <!-- cancer hallmark -->
          <v-btn v-show="bio_func_selected != '-'"
                 small
                 color="success"
                 class="mx-1"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshHallMark()">Hallmarks of Cancer</v-btn>
          <v-btn v-show="bio_func_selected != '-'"
                 small
                 color="success"
                 class="mx-1"
                 style="cursor: auto">IS</v-btn>
          <v-btn v-show="bio_func_selected != '-'"
                 class="mx-1"
                 small
                 color="info"
                 @mouseenter="addDeleteLine($event)"
                 @mouseleave="removeDeleteLine($event)"
                 @click="refreshHallMark()">
            {{cancer_hallmark}}
          </v-btn>
        </v-alert>
        <v-alert v-show="['nonmutational epigenetic reprogramming', 
          'enabling replicative immortality', 'polymorphic microbiomes'].includes(cancer_hallmark)"
                 color="success"
                 text
                 dense
                 outlined
                 border="left">
          Sorry, there is no splicing entries related to the selected hallmark of cancer !
        </v-alert>

        <div class="my-3"
             v-if="selected.length > 0">
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="success"
                     dark
                     v-bind="attrs"
                     v-on="on"
                     rounded
                     small
                     class="ml-2">
                <span class="font-weight-bold">Download</span>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="xls"
                              :data="selected"
                              name="Experimentally_supported_AS_events.xls">
                    <v-btn text
                           block> <span class="font-weight-bold">xls</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-list-item-title>
                  <json-excel type="csv"
                              :data="selected"
                              name="Experimentally_supported_AS_events.csv">
                    <v-btn text
                           block> <span class="font-weight-bold">csv</span> </v-btn>
                  </json-excel>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
        <v-data-table dense
                      v-model="selected"
                      class="data-table-style mt-4"
                      :headers=headers
                      fixed-header
                      :items="filteredSpliceVariant"
                      item-key="_id"
                      :search="search"
                      show-select
                      :single-select="singleSelect"
                      :loading="loading"
                      loading-text="Loading... Please wait"
                      hide-default-footer
                      :page.sync="currentPage"
                      :items-per-page="pageSize">
          <!-- item.gene_name slot -->
          <template v-slot:[`item.gene_name`]="{item}">
            <a @click="goToGeneSearchResult(item.gene_name)"
               color="info">
              <span class="font-weight-bold">{{item.gene_name}}</span>
            </a>
          </template>

          <!-- item.pubmed_id slot -->
          <template v-slot:[`item.pubmed_id`]="{item}">
            <a :href="pubmedLink+item.pubmed_id"
               color="info"
               target="_blank">{{item.pubmed_id}}</a>
          </template>

          <!-- item.visualization slot -->
          <template v-slot:[`item.visualization`]="{item}">
            <v-btn @click="goToVisualiztion(item.gene_name, item.as_type, item.event_coordinates)"
                   color="info"
                   icon
                   :disabled="['Complex', 'AF', 'AL'].includes(item.as_type)">
              <v-icon>mdi-tune</v-icon>
            </v-btn>
          </template>

          <!-- item.regulatory_network slot -->
          <template v-slot:[`item.regulatory_network`]="{item}">
            <v-btn @click="goToRegulationNetwork(item.gene_name)"
                   color="info"
                   icon>
              <svg class="icon"
                   aria-hidden="true">
                <use xlink:href="#icon-icon-copy"></use>
              </svg>
            </v-btn>
          </template>

          <!-- item.regulatory_explorer slot -->
          <template v-slot:[`item.regulatory_explorer`]="{item}">
            <v-btn @click="goToRegulationExplorer(item.gene_name, 'TCGA', item.tcga_project_id, item.event_id)"
                   color="grey"
                   icon
                   :disabled="item.has_oncoprint == 'no' || item.as_type == 'Complex'">
              <svg class="icon"
                   aria-hidden="true"
                   v-if="item.has_oncoprint == 'no' || item.as_type == 'Complex'">
                <use xlink:href="#icon-GridView-diable"></use>
              </svg>
              <svg class="icon"
                   aria-hidden="true"
                   v-else>
                <use xlink:href="#icon-GridView-oncoprint"></use>
              </svg>
            </v-btn>
          </template>

          <!-- item.survival slot -->
          <template v-slot:[`item.survival`]="{item}">
            <v-btn @click="goToSurvival(item.gene_name, 'TCGA', item.tcga_project_id, item.event_id)"
                   color="info"
                   icon
                   :disabled="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !survival_project_items.includes(item.tcga_project_id)">
              <svg class="icon"
                   aria-hidden="true"
                   v-if="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !survival_project_items.includes(item.tcga_project_id)">
                <use xlink:href="#icon-linechart-diable"></use>
              </svg>
              <svg class="icon"
                   aria-hidden="true"
                   v-else>
                <use xlink:href="#icon-linechart"></use>
              </svg>
            </v-btn>
          </template>

          <!-- item.staging slot -->
          <template v-slot:[`item.staging`]="{item}">
            <v-btn @click="goToStaging(item.gene_name, 'TCGA', item.tcga_project_id, item.event_id)"
                   color="info"
                   icon
                   :disabled="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !stage_project_items.includes(item.tcga_project_id)">
              <svg class="icon"
                   aria-hidden="true"
                   v-if="item.has_oncoprint == 'no' || item.as_type == 'Complex' || !stage_project_items.includes(item.tcga_project_id)">
                <use xlink:href="#icon-xiangxiantu-disable"></use>
              </svg>
              <svg class="icon"
                   aria-hidden="true"
                   v-else>
                <use xlink:href="#icon-xiangxiantu"></use>
              </svg>
            </v-btn>
          </template>

          <!-- item.details slot -->
          <template v-slot:[`item.details`]="{item}">
            <v-btn @click="goToDetails(item.event_id, item.cancer_name, item.pubmed_id)"
                   color="info"
                   icon>
              <v-icon>mdi-chevron-right-circle</v-icon>
            </v-btn>
          </template>

          <!-- header.data-table-select slot-->
          <template v-slot:[`header.data-table-select`]="{ on, props }">
            <v-simple-checkbox color="success"
                               v-bind="props"
                               v-on="on"></v-simple-checkbox>
          </template>

          <!-- item.data-table-select slot -->
          <template v-slot:[`item.data-table-select`]="{ isSelected, select }">
            <v-simple-checkbox color="info"
                               :value="isSelected"
                               @input="select($event)"></v-simple-checkbox>
          </template>

          <!-- header.regulatory_network slot -->
          <template v-slot:[`header.regulatory_network`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Splicing Regulatory Network</span>
            </v-tooltip>
          </template>

          <!-- header.regulatory_explorer slot -->
          <template v-slot:[`header.regulatory_explorer`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Splicing Regulatory Explorer</span>
            </v-tooltip>
          </template>

          <!-- header.survival slot -->
          <template v-slot:[`header.survival`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Survival Analysis</span>
            </v-tooltip>
          </template>

          <!-- header.staging slot -->
          <template v-slot:[`header.staging`]="{header}">
            {{header.text}}
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon small
                        v-bind="attrs"
                        v-on="on">mdi-help-circle</v-icon>
              </template>
              <span>Cancer Staging Analysis</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <div class="d-flex justify-center mt-2">
          <span class="text-body-1 mt-3">Items per page</span>
          <v-select v-model="pageSize"
                    dense
                    outlined
                    :items="pageSizes"
                    class="pagesize-select mt-1 mx-2"
                    @input="handlePageSizeChange(pageSize)">
          </v-select>
          <span class="text-body-1 mt-3 mx-2">Total <span class="font-weight-bold info--text">{{totalItems}}</span>
            items </span>
          <v-pagination v-model="currentPage"
                        color="info"
                        :length="totalPages"
                        :total-visible="8"
                        class="mx-1"
                        @input="handlePageChange"
                        prev-icon="mdi-menu-left"
                        next-icon="mdi-menu-right">
          </v-pagination>
          <span class="text-body-1 mt-2 mx-2">Page</span>
          <v-text-field outlined
                        dense
                        v-model="whichPage"
                        type="number"
                        class="jump-select"
                        append-icon="">
          </v-text-field>
          <v-btn color=""
                 depressed
                 outlined
                 class="mx-2"
                 @click="jumpPage()">Jump</v-btn>
        </div>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import { getSpliceKnowledge } from 'node/browse';
import JsonExcel from 'vue-json-excel';
import BackToTop from '@/components/main/BackToTop';
import * as d3 from 'd3-selection';

export default {
  name: 'SplicingEffect',
  components: {
    JsonExcel,
    BackToTop
  },
  data() {
    return {
      breadItems: [
        {
          text: 'Home',
          disabled: false,
          href: '/ascancer/home',
        },
        {
          text: 'Splicing Effect',
          disabled: true,
        },
      ],

      search: '',
      selected: [],
      singleSelect: false,
      loading: true,
      pubmedLink: 'https://pubmed.ncbi.nlm.nih.gov/',
      currentPage: 1,
      whichPage: 1,
      totalPages: 0,
      pageSize: 15,
      pageSizes: [10, 15, 20, 50, 100],
      totalItems: 0,
      headers: [
        { text: 'Gene Name', value: 'gene_name', align: 'start', sortable: true, },
        { text: 'Cancer Type', value: 'cancer_name', align: 'start', sortable: true },
        { text: 'AS Type', value: 'as_type', align: 'start', sortable: true },
        // { text: 'Event Coordinates', value: 'event_coordinates', align: 'start', },
        { text: 'ORF', value: 'orf_annotation', align: 'start', sortable: false },
        { text: 'Function', value: 'biological_function', align: 'start', sortable: false, },
        { text: 'PubMed', value: 'pubmed_id', align: 'start', sortable: false, },
        { text: 'Journal', value: 'journal', align: 'start', sortable: false, },
        { text: 'Visualization', value: 'visualization', align: 'center', sortable: false, },
        { text: 'Network', value: 'regulatory_network', align: 'center', sortable: false, },
        { text: 'Explorer', value: 'regulatory_explorer', align: 'center', sortable: false, },
        { text: 'Survival', value: 'survival', align: 'center', sortable: false, },
        { text: 'Staging', value: 'staging', align: 'center', sortable: false, },
        { text: 'Details', value: 'details', align: 'center', sortable: false, },
      ],

      bio_func_selected: "",
      cancer_hallmark: "",
      spliceVariant: [],

      survival_project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CESC", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-DLBC", "TCGA-ESCA", "TCGA-GBM", "TCGA-HNSC", "TCGA-KICH",
        "TCGA-KIRC", "TCGA-KIRP", "TCGA-LAML", "TCGA-LGG", "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO",
        "TCGA-OV", "TCGA-PAAD", "TCGA-PCPG", "TCGA-PRAD", "TCGA-READ", "TCGA-SARC",
        "TCGA-SKCM", "TCGA-STAD", "TCGA-THCA", "TCGA-THYM", "TCGA-UCEC", "TCGA-UCS", "TCGA-UVM",
      ],
      stage_project_items: ["TCGA-ACC", "TCGA-BLCA", "TCGA-BRCA", "TCGA-CHOL",
        "TCGA-COAD", "TCGA-ESCA", "TCGA-HNSC", "TCGA-KICH", "TCGA-KIRC", "TCGA-KIRP",
        "TCGA-LUAD", "TCGA-LUSC", "TCGA-MESO", "TCGA-PAAD", "TCGA-READ", "TCGA-SKCM",
        "TCGA-STAD", "TCGA-THCA",
      ],
    }
  },
  created() {
    if (JSON.stringify(this.$route.query) === '{}') {
      this.bio_func_selected = "-";
    } else if (JSON.stringify(this.$route.query) !== '{}') {
      // console.log(this.$route.query.functional);
      this.bio_func_selected = this.$route.query.functional;
    }
    // this.getSpliceKnowledge();
  },
  mounted() {
    // this.bio_func_selected = "-";
    // console.log(maphilight);
    // console.log(d3.select('#hallmark'));
    // d3.select('#hallmark').maphilight();
  },
  computed: {
    filteredSpliceVariant() {
      return this.spliceVariant;
    }
  },
  watch: {
    spliceVariant(val) {
      if (val) {
        this.loading = false;
      }
    },
    bio_func_selected(newVal, oldVal) {
      // console.log(newVal);
      // console.log(oldVal);
      if (newVal != oldVal) {
        // console.log(newVal);
        this.getSpliceKnowledge();
        if (newVal == "Cell Proliferation") {
          this.cancer_hallmark = "sustaining proliferative signaling"

        } else if (newVal == "Cell Growth") {
          this.cancer_hallmark = "evading growth supressors"

        } else if (newVal == "Immune") {
          this.cancer_hallmark = "avoiding immune destruction"

        } else if (newVal == "Inflammation") {
          this.cancer_hallmark = "tumor promoting inflammation"

        } else if (["EMT", "Metastasis", "Cell Migration", "Cell Invasion"].includes(newVal && newVal.split(',')[0])) {
          this.cancer_hallmark = "activating invasion and metastasis"

        } else if (newVal == "Angiogenesis") {
          this.cancer_hallmark = "inducing or accessing vasculature"

        } else if (newVal == "Senescence") {
          this.cancer_hallmark = "senescent cells"

        } else if (["DNA Damage", "DNA Repair"].includes(newVal && newVal.split(',')[0])) {
          this.cancer_hallmark = "genome instability and mutation"

        } else if (["Apoptosis", "Cell Survival", "Autophagy"].includes(newVal && newVal.split(',')[0])) {
          this.cancer_hallmark = "resisting cell death"

        } else if (["Cellular Reprograming", "Aerobic Glycolysis", "Metabolism"].includes(newVal && newVal.split(',')[0])) {
          this.cancer_hallmark = "deregulating cellular metabolism"

        } else if (["Cell Differentiation", "Impaired Hematopoiesis"].includes(newVal && newVal.split(',')[0])) {
          this.cancer_hallmark = "unlocking phenotypic plasticity"

        } else {
          this.cancer_hallmark = newVal;
        }
      }
    },
    cancer_hallmark(newValue, oldValue) {
      if (newValue != oldValue) {
        //   console.log(newValue);
        //   console.log(oldValue);

        // 获取首字母拼接字符串
        let key = '';
        if (oldValue) {
          oldValue.split(' ').forEach(d => {
            key = key + d[0];
          })
        }
        //   console.log(key);

        if (key && key != '-') {
          this.mouseLeaveRegion(key);
        }

        if (newValue == "sustaining proliferative signaling") {
          this.selectedRegion('sps');
        }
        else if (newValue == "evading growth supressors") {
          this.selectedRegion('egs');
        }
        else if (newValue == "avoiding immune destruction") {
          this.selectedRegion('aid');
        }
        else if (newValue == "tumor promoting inflammation") {
          this.selectedRegion('tpi');
        }
        else if (newValue == "activating invasion and metastasis") {
          this.selectedRegion('aiam');
        }
        else if (newValue == "inducing or accessing vasculature") {
          this.selectedRegion('ioav');
        }
        else if (newValue == "genome instability and mutation") {
          this.selectedRegion('giam');
        }
        else if (newValue == "resisting cell death") {
          this.selectedRegion('rcd');
        }
        else if (newValue == "deregulating cellular metabolism") {
          this.selectedRegion('dcm');
        }
        else if (newValue == "unlocking phenotypic plasticity") {
          this.selectedRegion('upp');
        }
      }

    }
  },
  methods: {
    clickRegion(item) {
      // console.log(item);
      this.currentPage = 1;
      if (item == "sps") {
        this.bio_func_selected = "Cell Proliferation";
        this.cancer_hallmark = "sustaining proliferative signaling"

      } else if (item == "egs") {
        this.bio_func_selected = "Cell Growth";
        this.cancer_hallmark = "evading growth supressors"

      } else if (item == "ner") {
        this.bio_func_selected = "-";
        this.cancer_hallmark = "nonmutational epigenetic reprogramming"

      } else if (item == "aid") {
        this.bio_func_selected = "Immune";
        this.cancer_hallmark = "avoiding immune destruction"

      } else if (item == "eri") {
        this.bio_func_selected = "-";
        this.cancer_hallmark = "enabling replicative immortality"

      } else if (item == "tpi") {
        this.bio_func_selected = "Inflammation";
        this.cancer_hallmark = "tumor promoting inflammation"

      } else if (item == "pm") {
        this.bio_func_selected = "-";
        this.cancer_hallmark = "polymorphic microbiomes"

      } else if (item == "aiam") {
        this.bio_func_selected = "EMT,Metastasis,Cell Migration,Cell Invasion";
        this.cancer_hallmark = "activating invasion and metastasis"

      } else if (item == "ioav") {
        this.bio_func_selected = "Angiogenesis";
        this.cancer_hallmark = "inducing or accessing vasculature"

      } else if (item == "sc") {
        this.bio_func_selected = "Senescence";
        this.cancer_hallmark = "senescent cells"

      } else if (item == "giam") {
        this.bio_func_selected = "DNA Damage,DNA Repair";
        this.cancer_hallmark = "genome instability and mutation"

      } else if (item == "rcd") {
        this.bio_func_selected = "Apoptosis,Cell Survival,Autophagy";
        this.cancer_hallmark = "resisting cell death"

      } else if (item == "dcm") {
        this.bio_func_selected = "Cellular Reprograming,Aerobic Glycolysis,Metabolism";
        this.cancer_hallmark = "deregulating cellular metabolism"

      } else if (item == "upp") {
        this.bio_func_selected = "Cell Differentiation,Impaired Hematopoiesis";
        this.cancer_hallmark = "unlocking phenotypic plasticity"
      }
    },
    mouseOverRegion(item) {
      // console.log(item);
      let path = d3.selectAll('#' + item);
      // console.log(path);
      path.attr('cursor', 'pointer').attr('stroke', 'black')
        .attr('stroke-width', '4px').attr('fill', '#eec42d')
      //   path.('cursor', 'pointer')
    },
    mouseLeaveRegion(item) {
      // console.log(item);
      let path = d3.selectAll('#' + item);
      // console.log(path);

      // 获取首字母拼接字符串
      let key = '';
      if (this.cancer_hallmark) {
        this.cancer_hallmark.split(' ').forEach(d => {
          key = key + d[0];
        })
      }
      key = key.toLowerCase()
      // console.log(key);

      if (key == item) {
        path.attr('stroke', 'black')
          .attr('stroke-width', '4px')
          .attr('fill', '#FF7043')
      } else {
        path.attr('stroke', 'black')
          .attr('stroke-width', '1px')
          .attr('fill', '#c4c2c2')
      }
    },
    selectedRegion(item) {
      let path = d3.selectAll('#' + item);
      path.attr('cursor', 'pointer').attr('stroke', 'black')
        .attr('stroke-width', '4px').attr('fill', '#FF7043')
    },
    getRequestParams(functional, page, pageSize) {
      let params = {};
      if (functional) {
        //   functional = functional.split(' ').map(f => f.charAt(0).toLowerCase() + f.slice(1)).join(' ');
        //   console.log(functional);
        params["functional"] = functional;
      } else {
        params["functional"] = "-";
      }
      if (page) {
        params["page"] = page - 1;
      }
      // console.log(page);
      if (pageSize) {
        params["size"] = pageSize;
      }
      return params;
    },
    async getSpliceKnowledge() {

      const params = this.getRequestParams(
        this.bio_func_selected,
        this.currentPage,
        this.pageSize
      );
      await getSpliceKnowledge(params).then((data) => {
        //   console.log(data);
        this.totalItems = data.totalItems;
        this.spliceVariant = data.items;
        this.currentPage = data.currentPage;
        this.totalPages = data.totalPages;

        this.$router.replace({
          path: '/biofunc',
          query: {
            functional: params.functional,
            page: params.page + 1,
            size: params.size,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            console.error(err);
          }
        });
      }).catch((err) => {
        console.error(err);
      });
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.whichPage = this.currentPage;
      this.getSpliceKnowledge();
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.getSpliceKnowledge();
    },
    jumpPage() {
      // console.log(+this.whichPage);
      if (+this.whichPage < 1) {
        this.whichPage = 1;
      }
      if (+this.whichPage > this.totalPages) {
        this.whichPage = this.totalPages;
      }
      this.currentPage = +this.whichPage;
      this.getSpliceKnowledge();
    },
    goToVisualiztion(genename, astype, coordinate) {
      this.$router.push({
        path: '/splicevis',
        query: {
          genename: genename,
          astype: astype,
          coordinate: coordinate
        }
        // NavigationDuplicated: Avoided redundant navigation to current location
        // (https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue)
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    goToGeneSearchResult(genename) {
      if (genename) {
        this.$router.push({
          path: '/search',
          query: {
            genename: genename,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else if (genename == null || genename == '') {
        window.alert("Sorry, please input the gene name !")
      }
    },
    goToRegulationNetwork(genename) {
      let regulator = genename;
      if (regulator) {
        this.$router.push({
          path: '/tools/regnet',
          query: {
            regulator: regulator,
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      } else if (regulator == null || regulator == '') {
        window.alert("Sorry, Gene cannot be null.")
      }
    },
    goToRegulationExplorer(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/regexp',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    goToSurvival(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/survival/asevent',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    goToStaging(genename, source, project, eventid) {
      if (genename && source && project != "-") {
        this.$router.push({
          path: '/tools/stage/asevent',
          query: {
            genename: genename,
            source: source,
            project: project,
            eventid: eventid
          }
        }).catch(err => {
          if (
            err.name !== 'NavigationDuplicated' &&
            !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            logError(err);
          }
        })
      }
    },
    goToDetails(eventid, cancername, pubmedid) {
      this.$router.push({
        path: '/browse/knowledge/details',
        query: {
          eventid: eventid,
          cancername: cancername,
          pubmedid: pubmedid
        }
        // NavigationDuplicated: Avoided redundant navigation to current location
        // (https://stackoverflow.com/questions/62462276/how-to-solve-avoided-redundant-navigation-to-current-location-error-in-vue)
      }).catch(err => {
        if (
          err.name !== 'NavigationDuplicated' &&
          !err.message.includes('Avoided redundant navigation to current location')
        ) {
          // But print any other errors to the console
          logError(err);
        }
      })
    },
    refreshHallMark() {
      this.bio_func_selected = "-";
    },
    addDeleteLine($event) {
      $event.currentTarget.classList.add('show-delete-line');
      // console.log($event.currentTarget.classList)
    },
    removeDeleteLine($event) {
      $event.currentTarget.classList.remove('show-delete-line');
    },

  },
}
</script>
<style scoped lang="sass">
a
      text-decoration: none
      color: #2196F3

a:hover
      text-decoration: underline

.v-btn
      text-transform: none
      letter-spacing: 0em
      font-size: 0.875rem

.v-data-table ::v-deep th
      font-size: 0.87rem !important
.v-data-table ::v-deep td
      font-size: 0.875rem !important

.v-sheet.v-card
      border-radius: 15px

.breadcrumb
      line-height: 1
      display: inline-block
      margin: 0 0
      vertical-align: middle
      padding: 8px 15px
      margin-top: -5px
      margin-bottom: 10px
      list-style: none
      background-color: #f5f5f5
      border-radius: 4px

.data-table-style
      border: thin solid rgba(0, 0, 0, 0.12)

.img
  // transform: scale(0.5, 0.5)
  // transform-origin: 50% 5%
      zoom: 0.4

.pagesize-select
      max-width: 6%

.jump-select
      max-width: 6%

.show-delete-line
      text-decoration: line-through

#cancer-hallmark
      width: 50%
      height: 40%

.cls-3
      font-size: 18px
      &,
      .cls-5
            fill: #231815
            font-family: Arial-BoldItalicMT, Arial
            font-weight: 700
            font-style: italic

.cls-4
      letter-spacing: -0.02em

.cls-5
      font-size: 24px

.cls-6
      fill: #5a5d6d

.cls-7
      fill: #aed371

.cls-8
      fill: #9cca5a

.cls-9
      fill: #464655

.cls-10
      fill: #040000

.cls-11
      fill: #a8d395

.cls-12
      fill: #fff

.cls-13
      fill: #c8d6e8

.cls-14
      fill: #ed8b9f

.cls-15
      fill: #d42142

.cls-16
      fill: #e15470

.cls-17
      fill: #73bd52

.cls-18
      fill: #f5d434

.cls-19
      fill: #3cb7a4

.cls-20
      fill: #16a68d

.cls-21
      fill: #f5b91b

.cls-22
      fill: #57545c

.cls-23
      fill: #39373f

.cls-24
      fill: #5a93cc

.cls-25
      fill: #6fa4d8

.cls-26
      fill: #82b4e2

.cls-27
      fill: #bf3d42

.cls-28
      fill: #903e53

.cls-29
      fill: #e84138

.cls-30
      fill: #eb5e49

.cls-31
      fill: #ef8064

.cls-32
      fill: #fbe0b7

.cls-33
      fill: #f7c3c7

.cls-34
      fill: #a5ced3

.cls-35
      fill: #8cb5c0

.cls-36
      fill: #a0cb42

.cls-37
      fill: #94c63c

.cls-38
      fill: #dfecc0

.cls-39
      fill: #e94b54

.cls-40
      fill: #e8343b

.cls-41
      fill: #f0841f

.cls-42
      fill: #ee761c

.cls-43
      fill: #88bf2e

.cls-44
      fill: #409bd6

.cls-45
      fill: #3387c9

.cls-46
      fill: #d4626b

.cls-47
      fill: #d87b82

.cls-48
      fill: #d04852

.cls-49
      fill: #cc323b

.cls-50
      fill: #163160

.cls-51
      fill: #4d9bd5
</style>